import React, { useEffect, useState } from "react";
import { CCollapse, CLink } from "@coreui/react";
import TimePicker from "rc-time-picker";
import moment from "moment";
import { Formik, Form, Field } from "formik";
import config from "../../config/config";
import axios from "axios";

import { toastError, toastSuccess } from "../../common/Toast";
import { SUCCESS_MESSAGE, ERROR_MESSAGE } from "../../common/Constant";
import Loader from "../Loader/Loader";

import "rc-time-picker/assets/index.css";

import { Time } from "../../common/imagePath";

const ApplicationSettings = (props) => {
  const [visibleApplicationSettings, setVisibleApplicationSettings] =
    useState(false);
  const [formValues, setFormValues] = useState({
    Language: false,
    DateFormat: "",
    TimeFormat: "",
    WeekStartDay: "",
    StoreOpeningTime: "",
    StoreClosingTime: "",
    PayVantage: false,
    EnableOfflineMode: false,
    AutoSyncOfflineSalesWhenBackOnline: false,
    OfflineModeSyncCycleTime: "",
    DarkMode: false,
    OnlyAllowEmployeesToSetCustomersInTheirLocation: false,
    DefaultNewCustomerToCurrentLocation: false,
    OnlyAllowEmployeesToSeeEmployeeWithLocation: false,
    RequireHttpsForProgram: false,
    HideExpiringItemsOnDashboard: false,
    DoNOTDeleteSavedCardAfterFailure: false,
    DoNotForceHTTPWhenNeededForEMVCreditCardProcessing: false,
    DisableTestMode: false,
    HideItemDescriptionInReports: false,
    EnableSoundsForStatusMessages: false,
    ShowLanguageSwitcher: false,
    ShowClockInHeader: false,
    LegacyDetailedReportExcelExport: false,
    OverwriteExistingItemsOnExcelImport: false,
    ReportSortOrder: "",
    SpeedUpSearchQueries: false,
    AllowPartialMatchForCustomerSearch: false,
    EnableQuickEditOnManagePages: false,
    EnableQuickExpenseAddUpdate: false,
    EnhancedSearchMethod: false,
    IncludeChildCategoriesWhenSearchingOrReporting: false,
    ShowFullCategoryPathWhenSearching: false,
    SpreadsheetFormat: "",
    MailingLabelsFormat: "",
    SessionExpiration: "",
    AlwaysMinimizeLeftSideBarMenu: false,
    AllowScanOfCustomerIntoItemField: false,
    SendSMSViaWhatsapp: false,
    EnableQuickCustomerAddUpdate: false,
    EnableQuickSupplierAddUpdate: false,
    EnableQuickItemAddUpdate: false,
    AdditionalAppointmentNoteBoldItalicUnderlineHereYouCanUseSomeKeywords: "",
    DoNOTDeleteSerialNumberWhenSelling: false,
  });
  const [loading, setLoading] = useState(false);
  const [time, setTime] = useState(new Date());
  const [comingApplicationSettings, setcomingApplicationSettings] = useState(
    props.visibleApplicationSettingsChange
  );

  const token = localStorage.getItem("Token");

  const handleSubmit = (values) => {
    const formArray = [
      { AppConfigkey: "Language", AppConfigvalue: values.Language },
      { AppConfigkey: "DateFormat", AppConfigvalue: values.DateFormat },
      { AppConfigkey: "TimeFormat", AppConfigvalue: values.TimeFormat },
      { AppConfigkey: "WeekStartDay", AppConfigvalue: values.WeekStartDay },
      {
        AppConfigkey: "StoreOpeningTime",
        AppConfigvalue: values.StoreOpeningTime,
      },
      {
        AppConfigkey: "StoreClosingTime",
        AppConfigvalue: values.StoreClosingTime,
      },
      { AppConfigkey: "PayVantage", AppConfigvalue: values.PayVantage },
      {
        AppConfigkey: "EnableOfflineMode",
        AppConfigvalue: values.EnableOfflineMode,
      },
      {
        AppConfigkey: "AutoSyncOfflineSalesWhenBackOnline",
        AppConfigvalue: values.AutoSyncOfflineSalesWhenBackOnline,
      },
      {
        AppConfigkey: "OfflineModeSyncCycleTime",
        AppConfigvalue: values.OfflineModeSyncCycleTime,
      },
      { AppConfigkey: "DarkMode", AppConfigvalue: values.DarkMode },
      {
        AppConfigkey: "OnlyAllowEmployeesToSetCustomersInTheirLocation",
        AppConfigvalue: values.OnlyAllowEmployeesToSetCustomersInTheirLocation,
      },
      {
        AppConfigkey: "DefaultNewCustomerToCurrentLocation",
        AppConfigvalue: values.DefaultNewCustomerToCurrentLocation,
      },
      {
        AppConfigkey: "OnlyAllowEmployeesToSeeEmployeeWithLocation",
        AppConfigvalue: values.OnlyAllowEmployeesToSeeEmployeeWithLocation,
      },
      {
        AppConfigkey: "RequireHttpsForProgram",
        AppConfigvalue: values.RequireHttpsForProgram,
      },
      {
        AppConfigkey: "HideExpiringItemsOnDashboard",
        AppConfigvalue: values.HideExpiringItemsOnDashboard,
      },
      {
        AppConfigkey: "DoNOTDeleteSavedCardAfterFailure",
        AppConfigvalue: values.DoNOTDeleteSavedCardAfterFailure,
      },
      {
        AppConfigkey: "DoNotForceHTTPWhenNeededForEMVCreditCardProcessing",
        AppConfigvalue:
          values.DoNotForceHTTPWhenNeededForEMVCreditCardProcessing,
      },
      {
        AppConfigkey: "DisableTestMode",
        AppConfigvalue: values.DisableTestMode,
      },
      {
        AppConfigkey: "HideItemDescriptionInReports",
        AppConfigvalue: values.HideItemDescriptionInReports,
      },
      {
        AppConfigkey: "EnableSoundsForStatusMessages",
        AppConfigvalue: values.EnableSoundsForStatusMessages,
      },
      {
        AppConfigkey: "ShowLanguageSwitcher",
        AppConfigvalue: values.ShowLanguageSwitcher,
      },
      {
        AppConfigkey: "ShowClockInHeader",
        AppConfigvalue: values.ShowClockInHeader,
      },
      {
        AppConfigkey: "LegacyDetailedReportExcelExport",
        AppConfigvalue: values.LegacyDetailedReportExcelExport,
      },
      {
        AppConfigkey: "OverwriteExistingItemsOnExcelImport",
        AppConfigvalue: values.OverwriteExistingItemsOnExcelImport,
      },
      {
        AppConfigkey: "ReportSortOrder",
        AppConfigvalue: values.ReportSortOrder,
      },
      {
        AppConfigkey: "SpeedUpSearchQueries",
        AppConfigvalue: values.SpeedUpSearchQueries,
      },
      {
        AppConfigkey: "AllowPartialMatchForCustomerSearch",
        AppConfigvalue: values.AllowPartialMatchForCustomerSearch,
      },
      {
        AppConfigkey: "EnableQuickEditOnManagePages",
        AppConfigvalue: values.EnableQuickEditOnManagePages,
      },
      {
        AppConfigkey: "EnableQuickExpenseAddUpdate",
        AppConfigvalue: values.EnableQuickExpenseAddUpdate,
      },
      {
        AppConfigkey: "EnhancedSearchMethod",
        AppConfigvalue: values.EnhancedSearchMethod,
      },
      {
        AppConfigkey: "IncludeChildCategoriesWhenSearchingOrReporting",
        AppConfigvalue: values.IncludeChildCategoriesWhenSearchingOrReporting,
      },
      {
        AppConfigkey: "ShowFullCategoryPathWhenSearching",
        AppConfigvalue: values.ShowFullCategoryPathWhenSearching,
      },
      {
        AppConfigkey: "SpreadsheetFormat",
        AppConfigvalue: values.SpreadsheetFormat,
      },
      {
        AppConfigkey: "MailingLabelsFormat",
        AppConfigvalue: values.MailingLabelsFormat,
      },
      {
        AppConfigkey: "SessionExpiration",
        AppConfigvalue: values.SessionExpiration,
      },
      {
        AppConfigkey: "AlwaysMinimizeLeftSideBarMenu",
        AppConfigvalue: values.AlwaysMinimizeLeftSideBarMenu,
      },
      {
        AppConfigkey: "AllowScanOfCustomerIntoItemField",
        AppConfigvalue: values.AllowScanOfCustomerIntoItemField,
      },
      {
        AppConfigkey: "SendSMSViaWhatsapp",
        AppConfigvalue: values.SendSMSViaWhatsapp,
      },
      {
        AppConfigkey: "EnableEBTPayments",
        AppConfigvalue: values.EnableEBTPayments,
      },
      {
        AppConfigkey: "EnableQuickSupplierAddUpdate",
        AppConfigvalue: values.EnableQuickSupplierAddUpdate,
      },
      {
        AppConfigkey: "EnableQuickItemAddUpdate",
        AppConfigvalue: values.EnableQuickItemAddUpdate,
      },
      {
        AppConfigkey:
          "AdditionalAppointmentNoteBoldItalicUnderlineHereYouCanUseSomeKeywords",
        AppConfigvalue:
          values.AdditionalAppointmentNoteBoldItalicUnderlineHereYouCanUseSomeKeywords,
      },
      {
        AppConfigkey: "DoNOTDeleteSerialNumberWhenSelling",
        AppConfigvalue: values.DoNOTDeleteSerialNumberWhenSelling,
      },
    ];

    const jsonobj = {};
    jsonobj.StoreConfig = formArray;

    let jsonstring = JSON.stringify(jsonobj);

    setLoading(true);

    axios
      .post(
        `${config.storeConfigBaseUrl}/storeconfig/upsert`,
        {
          type: "PAYMENT_TYPES",
          storeconfigxml: jsonstring,
        },
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            "Access-Control-Allow-Origin": "*",
            Authorization: token,
          },
        }
      )
      .then((res) => {
        if (res.data.ResponseCode === "SUCCESS" && res.data.ResponseID > 0) {
          toastSuccess(SUCCESS_MESSAGE);
        } else {
          toastError(ERROR_MESSAGE);
        }

        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
      });
  };

  //handleChange
  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    const fieldValue = type === "checkbox" ? checked : value;

    setFormValues((prevValues) => ({
      ...prevValues,
      [name]: fieldValue,
    }));
  };

  useEffect(() => {
    setLoading(true);

    axios
      .get(
        `${config.storeConfigBaseUrl}/storeconfig/getallconfig?type=PAYMENT_TYPES`,
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            "Access-Control-Allow-Origin": "*",
            Authorization: token,
          },
        }
      )
      .then((response) => {
        const responseData = response.data.ResponseData;

        responseData.map((data) => {
          if (data.AppConfigkey === "Language") {
            formValues.Language = data.AppConfigvalue;
          } else if (data.AppConfigkey === "DateFormat") {
            formValues.DateFormat = data.AppConfigvalue;
          } else if (data.AppConfigkey === "TimeFormat") {
            formValues.TimeFormat = data.AppConfigvalue;
          } else if (data.AppConfigkey === "WeekStartDay") {
            formValues.WeekStartDay = data.AppConfigvalue;
          } else if (data.AppConfigkey === "StoreOpeningTime") {
            formValues.StoreOpeningTime = data.AppConfigvalue;
          } else if (data.AppConfigkey === "StoreClosingTime") {
            formValues.StoreClosingTime = data.AppConfigvalue;
          } else if (data.AppConfigkey === "PayVantage") {
            formValues.PayVantage =
              data.AppConfigvalue === "false" ? false : true;
          } else if (data.AppConfigkey === "EnableOfflineMode") {
            formValues.EnableOfflineMode =
              data.AppConfigvalue === "false" ? false : true;
          } else if (
            data.AppConfigkey === "AutoSyncOfflineSalesWhenBackOnline"
          ) {
            formValues.AutoSyncOfflineSalesWhenBackOnline =
              data.AppConfigvalue === "false" ? false : true;
          } else if (data.AppConfigkey === "OfflineModeSyncCycleTime") {
            formValues.OfflineModeSyncCycleTime = data.AppConfigvalue;
          } else if (data.AppConfigkey === "DarkMode") {
            formValues.DarkMode =
              data.AppConfigvalue === "false" ? false : true;
          } else if (
            data.AppConfigkey ===
            "OnlyAllowEmployeesToSetCustomersInTheirLocation"
          ) {
            formValues.OnlyAllowEmployeesToSetCustomersInTheirLocation =
              data.AppConfigvalue === "false" ? false : true;
          } else if (
            data.AppConfigkey === "DefaultNewCustomerToCurrentLocation"
          ) {
            formValues.DefaultNewCustomerToCurrentLocation =
              data.AppConfigvalue === "false" ? false : true;
          } else if (
            data.AppConfigkey === "OnlyAllowEmployeesToSeeEmployeeWithLocation"
          ) {
            formValues.OnlyAllowEmployeesToSeeEmployeeWithLocation =
              data.AppConfigvalue === "false" ? false : true;
          } else if (data.AppConfigkey === "RequireHttpsForProgram") {
            formValues.RequireHttpsForProgram =
              data.AppConfigvalue === "false" ? false : true;
          } else if (data.AppConfigkey === "HideExpiringItemsOnDashboard") {
            formValues.HideExpiringItemsOnDashboard =
              data.AppConfigvalue === "false" ? false : true;
          } else if (data.AppConfigkey === "DoNOTDeleteSavedCardAfterFailure") {
            formValues.DoNOTDeleteSavedCardAfterFailure =
              data.AppConfigvalue === "false" ? false : true;
          } else if (
            data.AppConfigkey ===
            "DoNotForceHTTPWhenNeededForEMVCreditCardProcessing"
          ) {
            formValues.DoNotForceHTTPWhenNeededForEMVCreditCardProcessing =
              data.AppConfigvalue === "false" ? false : true;
          } else if (data.AppConfigkey === "DisableTestMode") {
            formValues.DisableTestMode =
              data.AppConfigvalue === "false" ? false : true;
          } else if (data.AppConfigkey === "HideItemDescriptionInReports") {
            formValues.HideItemDescriptionInReports =
              data.AppConfigvalue === "false" ? false : true;
          } else if (data.AppConfigkey === "EnableSoundsForStatusMessages") {
            formValues.EnableSoundsForStatusMessages =
              data.AppConfigvalue === "false" ? false : true;
          } else if (data.AppConfigkey === "ShowLanguageSwitcher") {
            formValues.ShowLanguageSwitcher =
              data.AppConfigvalue === "false" ? false : true;
          } else if (data.AppConfigkey === "ShowClockInHeader") {
            formValues.ShowClockInHeader =
              data.AppConfigvalue === "false" ? false : true;
          } else if (data.AppConfigkey === "LegacyDetailedReportExcelExport") {
            formValues.LegacyDetailedReportExcelExport =
              data.AppConfigvalue === "false" ? false : true;
          } else if (
            data.AppConfigkey === "OverwriteExistingItemsOnExcelImport"
          ) {
            formValues.OverwriteExistingItemsOnExcelImport =
              data.AppConfigvalue === "false" ? false : true;
          } else if (data.AppConfigkey === "ReportSortOrder") {
            formValues.ReportSortOrder =
              data.AppConfigvalue === "false" ? false : true;
          } else if (data.AppConfigkey === "SpeedUpSearchQueries") {
            formValues.SpeedUpSearchQueries =
              data.AppConfigvalue === "false" ? false : true;
          } else if (
            data.AppConfigkey === "AllowPartialMatchForCustomerSearch"
          ) {
            formValues.AllowPartialMatchForCustomerSearch = data.AppConfigvalue;
          } else if (data.AppConfigkey === "EnableQuickEditOnManagePages") {
            formValues.EnableQuickEditOnManagePages =
              data.AppConfigvalue === "false" ? false : true;
          } else if (data.AppConfigkey === "EnableQuickExpenseAddUpdate") {
            formValues.EnableQuickExpenseAddUpdate =
              data.AppConfigvalue === "false" ? false : true;
          } else if (data.AppConfigkey === "EnhancedSearchMethod") {
            formValues.EnhancedSearchMethod =
              data.AppConfigvalue === "false" ? false : true;
          } else if (
            data.AppConfigkey ===
            "IncludeChildCategoriesWhenSearchingOrReporting"
          ) {
            formValues.IncludeChildCategoriesWhenSearchingOrReporting =
              data.AppConfigvalue === "false" ? false : true;
          } else if (
            data.AppConfigkey === "ShowFullCategoryPathWhenSearching"
          ) {
            formValues.ShowFullCategoryPathWhenSearching =
              data.AppConfigvalue === "false" ? false : true;
          } else if (data.AppConfigkey === "SpreadsheetFormat") {
            formValues.SpreadsheetFormat = data.AppConfigvalue;
          } else if (data.AppConfigkey === "MailingLabelsFormat") {
            formValues.MailingLabelsFormat = data.AppConfigvalue;
          } else if (data.AppConfigkey === "SessionExpiration") {
            formValues.SessionExpiration = data.AppConfigvalue;
          } else if (data.AppConfigkey === "AlwaysMinimizeLeftSideBarMenu") {
            formValues.AlwaysMinimizeLeftSideBarMenu =
              data.AppConfigvalue === "false" ? false : true;
          } else if (data.AppConfigkey === "AllowScanOfCustomerIntoItemField") {
            formValues.AllowScanOfCustomerIntoItemField =
              data.AppConfigvalue === "false" ? false : true;
          } else if (data.AppConfigkey === "SendSMSViaWhatsapp") {
            formValues.SendSMSViaWhatsapp =
              data.AppConfigvalue === "false" ? false : true;
          } else if (data.AppConfigkey === "EnableEBTPayments") {
            formValues.EnableEBTPayments =
              data.AppConfigvalue === "false" ? false : true;
          } else if (data.AppConfigkey === "EnableQuickSupplierAddUpdate") {
            formValues.EnableQuickSupplierAddUpdate =
              data.AppConfigvalue === "false" ? false : true;
          } else if (data.AppConfigkey === "EnableQuickItemAddUpdate") {
            formValues.EnableQuickItemAddUpdate =
              data.AppConfigvalue === "false" ? false : true;
          } else if (
            data.AppConfigkey ===
            "AdditionalAppointmentNoteBoldItalicUnderlineHereYouCanUseSomeKeywords"
          ) {
            formValues.AdditionalAppointmentNoteBoldItalicUnderlineHereYouCanUseSomeKeywords =
              data.AppConfigvalue;
          } else if (
            data.AppConfigkey === "DoNOTDeleteSerialNumberWhenSelling"
          ) {
            formValues.DoNOTDeleteSerialNumberWhenSelling =
              data.AppConfigvalue === "false" ? false : true;
          }
        });

        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
      });
  }, []);

  const onChange = (e) => {
    setTime(moment(e).format("H:mm"));
  };

  const data = [
    {
      name: "Language:",
      input: (
        <>
          <div className="col-lg-10">
            <div className="input-group">
              <Field
                as="select"
                className="form-control form-small select"
                id="Language"
                name="Language"
                onChange={handleChange}
              >
                <option>English</option>
                <option>Indonesia</option>
                <option>Española</option>
                <option>Fançais</option>
                <option>Italiano</option>
                <option>Deutsch</option>
                <option>Nederlands</option>
                <option>Portugues</option>
                <option>العَرَبِيةُ‎‎</option>
                <option>Khmer</option>
                <option>Vietnamese</option>
                <option>中文</option>
                <option>繁體中文</option>
                <option>Tamil</option>
              </Field>
            </div>
          </div>
        </>
      ),
    },
    {
      name: "Date Format:",
      input: (
        <>
          <div className="col-lg-10">
            <div className="input-group">
              <Field
                as="select"
                className="form-control form-small select"
                id="DateFormat"
                name="DateFormat"
                onChange={handleChange}
              >
                <option>MM/dd/yyyy</option>
                <option>dd/MM/yyyy</option>
                <option>yyyy/MM/dd</option>
                <option>MM-dd-yyyy</option>
                <option>dd-MM-yyyy</option>
                <option>yyyy-MM-dd</option>
                {/* <option>12/30/2000</option>
                <option>30-12-2000</option>
                <option>2000-12-30</option> */}
              </Field>
            </div>
          </div>
        </>
      ),
    },
    {
      name: "Time Format:",
      input: (
        <>
          <div className="col-lg-10">
            <div className="input-group">
              <Field
                as="select"
                className="form-control form-small select"
                id="TimeFormat"
                name="TimeFormat"
                onChange={handleChange}
              >
                <option>1:00 PM</option>
                <option>13:00</option>
              </Field>
            </div>
          </div>
        </>
      ),
    },
    {
      name: "Week Start Day:",
      input: (
        <>
          <div className="col-lg-10">
            <div className="input-group">
              <Field
                as="select"
                className="form-control form-small select"
                id="WeekStartDay"
                name="WeekStartDay"
                onChange={handleChange}
              >
                <option>Monday</option>
                <option>Sunday</option>
              </Field>
            </div>
          </div>
        </>
      ),
    },
    {
      name: "Store Opening Time:",
      input: (
        <>
          <div className="col-lg-10">
            <div className="input-group">
              <span className="input-group-text" id="basic-addon1">
                <img src={Time} alt="img" />
              </span>
              <TimePicker
                value={time ? moment(time, "H:mm") : null}
                onChange={(e) => {
                  onChange(e);
                  handleChange();
                }}
                showSecond={false}
                style={{ width: "100%" }}
                id="StoreOpeningTime"
                name="StoreOpeningTime"
                // onChange={handleChange}
              />
            </div>
          </div>
        </>
      ),
    },
    {
      name: "Store Closing Time:",
      input: (
        <>
          <div className="col-lg-10">
            <div className="input-group">
              <span className="input-group-text" id="basic-addon1">
                <img src={Time} alt="img" />
              </span>
              <TimePicker
                value={time ? moment(time, "H:mm") : null}
                onChange={(e) => {
                  onChange(e);
                  handleChange();
                }}
                showSecond={false}
                style={{ width: "100%" }}
                id="StoreClosingTime"
                name="StoreClosingTime"
              />
            </div>
          </div>
        </>
      ),
    },
    {
      name: "PayVantage:",
      input: (
        <>
          <div className="col-lg-10">
            <div className="input-group">
              <Field
                className="form-check-input"
                style={{ width: "1.5em", height: "1.5em" }}
                type="checkbox"
                id="PayVantage"
                name="PayVantage"
                onChange={handleChange}
              />
            </div>
          </div>
        </>
      ),
    },
    {
      name: "Enable Offline Mode:",
      input: (
        <>
          <div className="col-lg-10">
            <div className="input-group">
              <Field
                className="form-check-input"
                style={{ width: "1.5em", height: "1.5em" }}
                type="checkbox"
                id="EnableOfflineMode"
                name="EnableOfflineMode"
                onChange={handleChange}
              />
            </div>
          </div>
        </>
      ),
    },
    {
      name: "Auto Sync Offline Sales When Back Online:",
      input: (
        <>
          <div className="col-lg-10">
            <div className="input-group">
              <Field
                className="form-check-input"
                style={{ width: "1.5em", height: "1.5em" }}
                type="checkbox"
                id="AutoSyncOfflineSalesWhenBackOnline"
                name="AutoSyncOfflineSalesWhenBackOnline"
                onChange={handleChange}
              />
            </div>
          </div>
        </>
      ),
    },
    {
      name: "Offline Mode Sync Cycle Time (Hour):",
      input: (
        <>
          <div className="col-lg-10">
            <div className="input-group">
              <Field
                as="select"
                className="form-control form-small select"
                id="OfflineModeSyncCycleTime"
                name="OfflineModeSyncCycleTime"
                onChange={handleChange}
              >
                <option>1</option>
                <option>2</option>
                <option>3</option>
                <option>4</option>
                <option>5</option>
                <option>6</option>
                <option>7</option>
                <option>8</option>
                <option>9</option>
                <option>10</option>
                <option>11</option>
                <option>12</option>
                <option>13</option>
                <option>14</option>
                <option>15</option>
                <option>16</option>
                <option>17</option>
                <option>18</option>
                <option>19</option>
                <option>20</option>
                <option>21</option>
                <option>22</option>
                <option>23</option>
                <option>24</option>
                <option>25</option>
                <option>26</option>
                <option>27</option>
                <option>28</option>
                <option>29</option>
                <option>30</option>
                <option>31</option>
                <option>32</option>
                <option>33</option>
                <option>34</option>
                <option>35</option>
                <option>36</option>
                <option>37</option>
                <option>38</option>
                <option>39</option>
                <option>40</option>
                <option>41</option>
                <option>42</option>
                <option>43</option>
                <option>44</option>
                <option>45</option>
                <option>46</option>
                <option>47</option>
                <option>48</option>
              </Field>
            </div>
          </div>
        </>
      ),
    },
    {
      name: "Dark Mode:",
      input: (
        <>
          <div className="col-lg-10">
            <div className="input-group">
              <Field
                className="form-check-input"
                style={{ width: "1.5em", height: "1.5em" }}
                type="checkbox"
                id="DarkMode"
                name="DarkMode"
                onChange={handleChange}
              />
            </div>
          </div>
        </>
      ),
    },
    {
      name: "Only Allow Employees To Set Customers In Their Location:",
      input: (
        <>
          <div className="col-lg-10">
            <div className="input-group">
              <Field
                className="form-check-input"
                style={{ width: "1.5em", height: "1.5em" }}
                type="checkbox"
                id="OnlyAllowEmployeesToSetCustomersInTheirLocation"
                name="OnlyAllowEmployeesToSetCustomersInTheirLocation"
                onChange={handleChange}
              />
            </div>
          </div>
        </>
      ),
    },
    {
      name: "Default New Customer To Current Location:",
      input: (
        <>
          <div className="col-lg-10">
            <div className="input-group">
              <Field
                className="form-check-input"
                style={{ width: "1.5em", height: "1.5em" }}
                type="checkbox"
                id="DefaultNewCustomerToCurrentLocation"
                name="DefaultNewCustomerToCurrentLocation"
                onChange={handleChange}
              />
            </div>
          </div>
        </>
      ),
    },
    {
      name: "Only Allow Employees To See Employee With Location:",
      input: (
        <>
          <div className="col-lg-10">
            <div className="input-group">
              <Field
                className="form-check-input"
                style={{ width: "1.5em", height: "1.5em" }}
                type="checkbox"
                id="OnlyAllowEmployeesToSeeEmployeeWithLocation"
                name="OnlyAllowEmployeesToSeeEmployeeWithLocation"
                onChange={handleChange}
              />
            </div>
          </div>
        </>
      ),
    },
    {
      name: "Require Https For Program:",
      input: (
        <>
          <div className="col-lg-10">
            <div className="input-group">
              <Field
                className="form-check-input"
                style={{ width: "1.5em", height: "1.5em" }}
                type="checkbox"
                id="RequireHttpsForProgram"
                name="RequireHttpsForProgram"
                onChange={handleChange}
              />
            </div>
          </div>
        </>
      ),
    },
    {
      name: "Hide Expiring Items On Dashboard:",
      input: (
        <>
          <div className="col-lg-10">
            <div className="input-group">
              <Field
                className="form-check-input"
                style={{ width: "1.5em", height: "1.5em" }}
                type="checkbox"
                id="HideExpiringItemsOnDashboard"
                name="HideExpiringItemsOnDashboard"
                onChange={handleChange}
              />
            </div>
          </div>
        </>
      ),
    },
    {
      name: "Do NOT Delete Saved Card After Failure:",
      input: (
        <>
          <div className="col-lg-10">
            <div className="input-group">
              <Field
                className="form-check-input"
                style={{ width: "1.5em", height: "1.5em" }}
                type="checkbox"
                id="DoNOTDeleteSavedCardAfterFailure"
                name="DoNOTDeleteSavedCardAfterFailure"
                onChange={handleChange}
              />
            </div>
          </div>
        </>
      ),
    },
    {
      name: "Do Not Force HTTP When Needed For EMV Credit Card Processing:",
      input: (
        <>
          <div className="col-lg-10">
            <div className="input-group">
              <Field
                className="form-check-input"
                style={{ width: "1.5em", height: "1.5em", marginTop: "8px" }}
                type="checkbox"
                id="DoNotForceHTTPWhenNeededForEMVCreditCardProcessing"
                name="DoNotForceHTTPWhenNeededForEMVCreditCardProcessing"
                onChange={handleChange}
              />
            </div>
          </div>
        </>
      ),
    },
    {
      name: "Disable Test Mode:",
      input: (
        <>
          <div className="col-lg-10">
            <div className="input-group">
              <Field
                className="form-check-input"
                style={{ width: "1.5em", height: "1.5em", marginTop: "6px" }}
                type="checkbox"
                id="DisableTestMode"
                name="DisableTestMode"
                onChange={handleChange}
              />
            </div>
          </div>
        </>
      ),
    },
    {
      name: "Hide Item Description In Reports:",
      input: (
        <>
          <div className="col-lg-10">
            <div className="input-group">
              <Field
                className="form-check-input"
                style={{ width: "1.5em", height: "1.5em", marginTop: "6px" }}
                type="checkbox"
                id="HideItemDescriptionInReports"
                name="HideItemDescriptionInReports"
                onChange={handleChange}
              />
            </div>
          </div>
        </>
      ),
    },
    {
      name: "Enable Sounds For Status Messages:",
      input: (
        <>
          <div className="col-lg-10">
            <div className="input-group">
              <Field
                className="form-check-input"
                style={{ width: "1.5em", height: "1.5em", marginTop: "6px" }}
                type="checkbox"
                id="EnableSoundsForStatusMessages"
                name="EnableSoundsForStatusMessages"
                onChange={handleChange}
              />
            </div>
          </div>
        </>
      ),
    },
    {
      name: "Show Language Switcher:",
      input: (
        <>
          <div className="col-lg-10">
            <div className="input-group">
              <Field
                className="form-check-input"
                style={{ width: "1.5em", height: "1.5em", marginTop: "6px" }}
                type="checkbox"
                id="ShowLanguageSwitcher"
                name="ShowLanguageSwitcher"
                onChange={handleChange}
              />
            </div>
          </div>
        </>
      ),
    },
    {
      name: "Show Clock In Header:",
      input: (
        <>
          <div className="col-lg-10">
            <div className="input-group">
              <Field
                className="form-check-input"
                style={{ width: "1.5em", height: "1.5em", marginTop: "6px" }}
                type="checkbox"
                id="ShowClockInHeader"
                name="ShowClockInHeader"
                onChange={handleChange}
              />
            </div>
            This is visible only on wide screens
          </div>
        </>
      ),
    },
    {
      name: "Legacy Detailed Report Excel Export:",
      input: (
        <>
          <div className="col-lg-10">
            <div className="input-group">
              <Field
                className="form-check-input"
                style={{ width: "1.5em", height: "1.5em", marginTop: "6px" }}
                type="checkbox"
                id="LegacyDetailedReportExcelExport"
                name="LegacyDetailedReportExcelExport"
                onChange={handleChange}
              />
            </div>
          </div>
        </>
      ),
    },
    {
      name: "Overwrite Existing Items On Excel Import:",
      input: (
        <>
          <div className="col-lg-10">
            <div className="input-group">
              <Field
                className="form-check-input"
                style={{ width: "1.5em", height: "1.5em", marginTop: "6px" }}
                type="checkbox"
                id="OverwriteExistingItemsOnExcelImport"
                name="OverwriteExistingItemsOnExcelImport"
                onChange={handleChange}
              />
            </div>
          </div>
        </>
      ),
    },
    {
      name: "Report Sort Order:",
      input: (
        <>
          <div className="col-lg-10">
            <div className="input-group">
              <Field
                as="select"
                className="form-control form-small select"
                id="ReportSortOrder"
                name="ReportSortOrder"
                onChange={handleChange}
              >
                <option>Oldest First</option>
                <option>Newest First</option>
              </Field>
            </div>
          </div>
        </>
      ),
    },
    {
      name: "Speed Up Search Queries? (Only Recommend If You Have More Than 10,000 Items Or Customers):",
      input: (
        <>
          <div className="col-lg-10">
            <div className="input-group">
              <Field
                className="form-check-input"
                style={{ width: "1.5em", height: "1.5em", marginTop: "8px" }}
                type="checkbox"
                id="SpeedUpSearchQueries"
                name="SpeedUpSearchQueries"
                onChange={handleChange}
              />
            </div>
          </div>
        </>
      ),
    },
    {
      name: "Allow Partial Match For Customer Search:",
      input: (
        <>
          <div className="col-lg-10">
            <div className="input-group">
              <Field
                className="form-check-input"
                style={{ width: "1.5em", height: "1.5em", marginTop: "6px" }}
                type="checkbox"
                id="AllowPartialMatchForCustomerSearch"
                name="AllowPartialMatchForCustomerSearch"
                onChange={handleChange}
              />
            </div>
          </div>
        </>
      ),
    },
    {
      name: "Enable Quick Edit On Manage Pages:",
      input: (
        <>
          <div className="col-lg-10">
            <div className="input-group">
              <Field
                className="form-check-input"
                style={{ width: "1.5em", height: "1.5em", marginTop: "6px" }}
                type="checkbox"
                id="EnableQuickEditOnManagePages"
                name="EnableQuickEditOnManagePages"
                onChange={handleChange}
              />
            </div>
          </div>
        </>
      ),
    },
    {
      name: "Enable Quick Expense Add/Update:",
      input: (
        <>
          <div className="col-lg-10">
            <div className="input-group">
              <Field
                className="form-check-input"
                style={{ width: "1.5em", height: "1.5em", marginTop: "6px" }}
                type="checkbox"
                id="EnableQuickExpenseAddUpdate"
                name="EnableQuickExpenseAddUpdate"
                onChange={handleChange}
              />
            </div>
          </div>
        </>
      ),
    },
    {
      name: "Enhanced Search Method:",
      input: (
        <>
          <div className="col-lg-10">
            <div className="input-group">
              <Field
                className="form-check-input"
                style={{ width: "1.5em", height: "1.5em", marginTop: "6px" }}
                type="checkbox"
                id="EnhancedSearchMethod"
                name="EnhancedSearchMethod"
                onChange={handleChange}
              />
            </div>
          </div>
        </>
      ),
    },
    {
      name: "Include Child Categories When Searching Or Reporting:",
      input: (
        <>
          <div className="col-lg-10">
            <div className="input-group">
              <Field
                className="form-check-input"
                style={{ width: "1.5em", height: "1.5em", marginTop: "8px" }}
                type="checkbox"
                id="IncludeChildCategoriesWhenSearchingOrReporting"
                name="IncludeChildCategoriesWhenSearchingOrReporting"
                onChange={handleChange}
              />
            </div>
          </div>
        </>
      ),
    },
    {
      name: "Show Full Category Path When Searching:",
      input: (
        <>
          <div className="col-lg-10">
            <div className="input-group">
              <Field
                className="form-check-input"
                style={{ width: "1.5em", height: "1.5em", marginTop: "6px" }}
                type="checkbox"
                id="ShowFullCategoryPathWhenSearching"
                name="ShowFullCategoryPathWhenSearching"
                onChange={handleChange}
              />
            </div>
          </div>
        </>
      ),
    },
    {
      name: "Spreadsheet Format:",
      input: (
        <>
          <div className="col-lg-10">
            <div className="input-group">
              <Field
                as="select"
                className="form-control form-small select"
                id="SpreadsheetFormat"
                name="SpreadsheetFormat"
                onChange={handleChange}
              >
                <option>CSV</option>
                <option>XLSX</option>
              </Field>
            </div>
          </div>
        </>
      ),
    },
    {
      name: "Mailing Labels Format:",
      input: (
        <>
          <div className="col-lg-10">
            <div className="input-group">
              <Field
                as="select"
                className="form-control form-small select"
                id="MailingLabelsFormat"
                name="MailingLabelsFormat"
                onChange={handleChange}
              >
                <option>PDF</option>
                <option>Excel</option>
              </Field>
            </div>
          </div>
        </>
      ),
    },
    {
      name: "Session Expiration:",
      input: (
        <>
          <div className="col-lg-10">
            <div className="input-group">
              <Field
                as="select"
                className="form-control form-small select"
                id="SessionExpiration"
                name="SessionExpiration"
                onChange={handleChange}
              >
                <option value="0">On Browser Close</option>
                <option value="600">10 Minutes</option>
                <option value="900">15 Minutes</option>
                <option value="1200">20 Minutes</option>
                <option value="1500">25 Minutes</option>
                <option value="1800">30 Minutes</option>
                <option value="2100">35 Minutes</option>
                <option value="2400">40 Minutes</option>
                <option value="2700">45 Minutes</option>
                <option value="3000">50 Minutes</option>
                <option value="3300">55 Minutes</option>
                <option value="3600">1 Hours</option>
                <option value="7200">2 Hours</option>
                <option value="10800">3 Hours</option>
                <option value="14400">4 Hours</option>
                <option value="18000">5 Hours</option>
                <option value="21600">6 Hours</option>
                <option value="25200">7 Hours</option>
                <option value="28800">8 Hours</option>
                <option value="32400">9 Hours</option>
                <option value="36000">10 Hours</option>
                <option value="39600">11 Hours</option>
                <option value="43200">12 Hours</option>
                <option value="46800">13 Hours</option>
                <option value="50400">14 Hours</option>
                <option value="54000">15 Hours</option>
                <option value="57600">16 Hours</option>
                <option value="61200">17 Hours</option>
                <option value="64800">18 Hours</option>
                <option value="68400">19 Hours</option>
                <option value="72000">20 Hours</option>
                <option value="75600">21 Hours</option>
                <option value="79200">22 Hours</option>
                <option value="82800">23 Hours</option>
                <option value="86400">24 Hours</option>
                <option value="90000">25 Hours</option>
                <option value="93600">26 Hours</option>
                <option value="97200">27 Hours</option>
                <option value="100800">28 Hours</option>
                <option value="104400">29 Hours</option>
                <option value="108000">30 Hours</option>
                <option value="111600">31 Hours</option>
                <option value="115200">32 Hours</option>
                <option value="118800">33 Hours</option>
                <option value="122400">34 Hours</option>
                <option value="126000">35 Hours</option>
                <option value="129600">36 Hours</option>
                <option value="133200">37 Hours</option>
                <option value="136800">38 Hours</option>
                <option value="140400">39 Hours</option>
                <option value="144000">40 Hours</option>
                <option value="147600">41 Hours</option>
                <option value="151200">42 Hours</option>
                <option value="154800">43 Hours</option>
                <option value="158400">44 Hours</option>
                <option value="162000">45 Hours</option>
                <option value="165600">46 Hours</option>
                <option value="169200">47 Hours</option>
                <option value="172800">48 Hours</option>
                <option value="176400">49 Hours</option>
                <option value="180000">50 Hours</option>
                <option value="183600">51 Hours</option>
                <option value="187200">52 Hours</option>
                <option value="190800">53 Hours</option>
                <option value="194400">54 Hours</option>
                <option value="198000">55 Hours</option>
                <option value="201600">56 Hours</option>
                <option value="205200">57 Hours</option>
                <option value="208800">58 Hours</option>
                <option value="212400">59 Hours</option>
                <option value="216000">60 Hours</option>
                <option value="219600">61 Hours</option>
                <option value="223200">62 Hours</option>
                <option value="226800">63 Hours</option>
                <option value="230400">64 Hours</option>
                <option value="234000">65 Hours</option>
                <option value="237600">66 Hours</option>
                <option value="241200">67 Hours</option>
                <option value="244800">68 Hours</option>
                <option value="248400">69 Hours</option>
                <option value="252000">70 Hours</option>
                <option value="255600">71 Hours</option>
                <option value="259200">72 Hours</option>
                <option value="262800">73 Hours</option>
                <option value="266400">74 Hours</option>
                <option value="270000">75 Hours</option>
                <option value="273600">76 Hours</option>
                <option value="277200">77 Hours</option>
                <option value="280800">78 Hours</option>
                <option value="284400">79 Hours</option>
                <option value="288000">80 Hours</option>
                <option value="291600">81 Hours</option>
                <option value="295200">82 Hours</option>
                <option value="298800">83 Hours</option>
                <option value="302400">84 Hours</option>
                <option value="306000">85 Hours</option>
                <option value="309600">86 Hours</option>
                <option value="313200">87 Hours</option>
                <option value="316800">88 Hours</option>
                <option value="320400">89 Hours</option>
                <option value="324000">90 Hours</option>
                <option value="327600">91 Hours</option>
                <option value="331200">92 Hours</option>
                <option value="334800">93 Hours</option>
                <option value="338400">94 Hours</option>
                <option value="342000">95 Hours</option>
                <option value="345600">96 Hours</option>
                <option value="349200">97 Hours</option>
                <option value="352800">98 Hours</option>
                <option value="356400">99 Hours</option>
                <option value="360000">100 Hours</option>
                <option value="363600">101 Hours</option>
                <option value="367200">102 Hours</option>
                <option value="370800">103 Hours</option>
                <option value="374400">104 Hours</option>
                <option value="378000">105 Hours</option>
                <option value="381600">106 Hours</option>
                <option value="385200">107 Hours</option>
                <option value="388800">108 Hours</option>
                <option value="392400">109 Hours</option>
                <option value="396000">110 Hours</option>
                <option value="399600">111 Hours</option>
                <option value="403200">112 Hours</option>
                <option value="406800">113 Hours</option>
                <option value="410400">114 Hours</option>
                <option value="414000">115 Hours</option>
                <option value="417600">116 Hours</option>
                <option value="421200">117 Hours</option>
                <option value="424800">118 Hours</option>
                <option value="428400">119 Hours</option>
                <option value="432000">120 Hours</option>
                <option value="435600">121 Hours</option>
                <option value="439200">122 Hours</option>
                <option value="442800">123 Hours</option>
                <option value="446400">124 Hours</option>
                <option value="450000">125 Hours</option>
                <option value="453600">126 Hours</option>
                <option value="457200">127 Hours</option>
                <option value="460800">128 Hours</option>
                <option value="464400">129 Hours</option>
                <option value="468000">130 Hours</option>
                <option value="471600">131 Hours</option>
                <option value="475200">132 Hours</option>
                <option value="478800">133 Hours</option>
                <option value="482400">134 Hours</option>
                <option value="486000">135 Hours</option>
                <option value="489600">136 Hours</option>
                <option value="493200">137 Hours</option>
                <option value="496800">138 Hours</option>
                <option value="500400">139 Hours</option>
                <option value="504000">140 Hours</option>
                <option value="507600">141 Hours</option>
                <option value="511200">142 Hours</option>
                <option value="514800">143 Hours</option>
                <option value="518400">144 Hours</option>
                <option value="522000">145 Hours</option>
                <option value="525600">146 Hours</option>
                <option value="529200">147 Hours</option>
                <option value="532800">148 Hours</option>
                <option value="536400">149 Hours</option>
                <option value="540000">150 Hours</option>
                <option value="543600">151 Hours</option>
                <option value="547200">152 Hours</option>
                <option value="550800">153 Hours</option>
                <option value="554400">154 Hours</option>
                <option value="558000">155 Hours</option>
                <option value="561600">156 Hours</option>
                <option value="565200">157 Hours</option>
                <option value="568800">158 Hours</option>
                <option value="572400">159 Hours</option>
                <option value="576000">160 Hours</option>
                <option value="579600">161 Hours</option>
                <option value="583200">162 Hours</option>
                <option value="586800">163 Hours</option>
                <option value="590400">164 Hours</option>
                <option value="594000">165 Hours</option>
                <option value="597600">166 Hours</option>
                <option value="601200">167 Hours</option>
                <option value="604800">168 Hours</option>
              </Field>
            </div>
          </div>
        </>
      ),
    },
    {
      name: "Always Minimize Left Side Bar Menu:",
      input: (
        <>
          <div className="col-lg-10">
            <div className="input-group">
              <Field
                className="form-check-input"
                style={{ width: "1.5em", height: "1.5em", marginTop: "6px" }}
                type="checkbox"
                id="AlwaysMinimizeLeftSideBarMenu"
                name="AlwaysMinimizeLeftSideBarMenu"
                onChange={handleChange}
              />
            </div>
          </div>
        </>
      ),
    },
    {
      name: "Allow Scan Of Customer Into Item Field:",
      input: (
        <>
          <div className="col-lg-10">
            <div className="input-group">
              <Field
                className="form-check-input"
                style={{ width: "1.5em", height: "1.5em", marginTop: "6px" }}
                type="checkbox"
                id="AllowScanOfCustomerIntoItemField"
                name="AllowScanOfCustomerIntoItemField"
                onChange={handleChange}
              />
            </div>
          </div>
        </>
      ),
    },
    {
      name: "Send SMS Via Whatsapp:",
      input: (
        <>
          <div className="col-lg-10">
            <div className="input-group">
              <Field
                className="form-check-input"
                style={{ width: "1.5em", height: "1.5em", marginTop: "6px" }}
                type="checkbox"
                id="SendSMSViaWhatsapp"
                name="SendSMSViaWhatsapp"
                onChange={handleChange}
              />
            </div>
          </div>
        </>
      ),
    },
    {
      name: "Enable Quick Customer Add/Update:",
      input: (
        <>
          <div className="col-lg-10">
            <div className="input-group">
              <Field
                className="form-check-input"
                style={{ width: "1.5em", height: "1.5em", marginTop: "6px" }}
                type="checkbox"
                id="EnableQuickCustomerAddUpdate"
                name="EnableQuickCustomerAddUpdate"
                onChange={handleChange}
              />
            </div>
          </div>
        </>
      ),
    },
    {
      name: "Enable Quick Supplier Add/Update:",
      input: (
        <>
          <div className="col-lg-10">
            <div className="input-group">
              <Field
                className="form-check-input"
                style={{ width: "1.5em", height: "1.5em", marginTop: "6px" }}
                type="checkbox"
                id="EnableQuickSupplierAddUpdate"
                name="EnableQuickSupplierAddUpdate"
                onChange={handleChange}
              />
            </div>
          </div>
        </>
      ),
    },
    {
      name: "Enable Quick Item Add/Update:",
      input: (
        <>
          <div className="col-lg-10">
            <div className="input-group">
              <Field
                className="form-check-input"
                style={{ width: "1.5em", height: "1.5em", marginTop: "6px" }}
                type="checkbox"
                id="EnableQuickItemAddUpdate"
                name="EnableQuickItemAddUpdate"
                onChange={handleChange}
              />
            </div>
          </div>
        </>
      ),
    },
    {
      name: "Additional Appointment Note **Bold**, ~~Italic~~,||Underline|| Here, You Can Use Some Keywords.",
      input: (
        <>
          <div className="col-lg-10">
            <div className="input-group">
              <Field
                as="textarea"
                className="form-control"
                rows={3}
                id="AdditionalAppointmentNoteBoldItalicUnderlineHereYouCanUseSomeKeywords"
                name="AdditionalAppointmentNoteBoldItalicUnderlineHereYouCanUseSomeKeywords"
                onChange={handleChange}
              ></Field>
            </div>
          </div>
        </>
      ),
    },
    {
      name: "Do NOT Delete Serial Number When Selling:",
      input: (
        <>
          <div className="col-lg-10">
            <div className="input-group">
              <Field
                className="form-check-input"
                style={{ width: "1.5em", height: "1.5em", marginTop: "6px" }}
                type="checkbox"
                id="DoNOTDeleteSerialNumberWhenSelling"
                name="DoNOTDeleteSerialNumberWhenSelling"
                onChange={handleChange}
              />
            </div>
          </div>
        </>
      ),
    },
  ];

  const matchesSearchQuery = data?.filter((el) => {
    return el?.name?.toLowerCase().includes(props.searchQuery.toLowerCase());
  });

  return (
    <>
      {/*  */}
      {/* <Loader loading={loading} /> */}
      {matchesSearchQuery.length === data.length ? (
        <div className="card">
          <div
            style={{ padding: "0px", marginTop: "16px", marginLeft: "18px" }}
            className="card-header"
          >
            <h5 className="card-title">
              <CLink
                style={{ color: "var(--primary-main-color)" }}
                onClick={() => {
                  setVisibleApplicationSettings(!visibleApplicationSettings);
                  setcomingApplicationSettings(!!comingApplicationSettings);
                }}
              >
                Application Settings
              </CLink>
            </h5>
          </div>
          <CCollapse
            visible={
              visibleApplicationSettings ||
              props.visibleApplicationSettingsChange
            }
          >
            <div className="card-body">
              <span className="text-danger">
                Language cannot be saved at application level. However the
                default admin employee can change the language using the
                selector in the header of the program
              </span>
              <br />
              <br />
              <Formik
                {...props}
                initialValues={formValues}
                onSubmit={handleSubmit}
                enableReinitialize
              >
                {({ handleChange }) => (
                  <Form>
                    <div
                      style={{
                        display: "flex",
                        width: "70%",
                        flexDirection: "column",
                        alignItems: "flex-start",
                      }}
                    >
                      {matchesSearchQuery &&
                        matchesSearchQuery?.map((el) => (
                          <div
                            style={{
                              width: "100%",
                              display: "flex",
                              justifyContent: "space-between",
                              marginTop: "10px",
                            }}
                          >
                            <label
                              className="col-form-label"
                              style={{ fontSize: "15px" }}
                            >
                              {el.name}
                            </label>
                            <div style={{ width: "53%" }}>{el.input}</div>
                          </div>
                        ))}
                    </div>
                    {/* <div className="form-group row">
                    <label className="col-form-label col-lg-2">Language:</label>
                    <div className="col-lg-10">
                      <div className="input-group">
                        <Field
                          as="select"
                          className="form-control form-small select"
                          id="Language"
                          name="Language"
                          onChange={handleChange}
                        >
                          <option>English</option>
                          <option>Indonesia</option>
                          <option>Española</option>
                          <option>Fançais</option>
                          <option>Italiano</option>
                          <option>Deutsch</option>
                          <option>Nederlands</option>
                          <option>Portugues</option>
                          <option>العَرَبِيةُ‎‎</option>
                          <option>Khmer</option>
                          <option>Vietnamese</option>
                          <option>中文</option>
                          <option>繁體中文</option>
                          <option>Tamil</option>
                        </Field>
                      </div>
                    </div>
                  </div> */}
                    {/* <div className="form-group row">
                    <label className="col-form-label col-lg-2">
                      Date Format:
                    </label>
                    <div className="col-lg-10">
                      <div className="input-group">
                        <Field
                          as="select"
                          className="form-control form-small select"
                          id="DateFormat"
                          name="DateFormat"
                          onChange={handleChange}
                        >
                          <option>12/30/2000</option>
                          <option>30-12-2000</option>
                          <option>2000-12-30</option>
                        </Field>
                      </div>
                    </div>
                  </div> */}
                    {/* <div className="form-group row">
                    <label className="col-form-label col-lg-2">
                      Time Format:
                    </label>
                    <div className="col-lg-10">
                      <div className="input-group">
                        <Field
                          as="select"
                          className="form-control form-small select"
                          id="TimeFormat"
                          name="TimeFormat"
                          onChange={handleChange}
                        >
                          <option>1:00 PM</option>
                          <option>13:00</option>
                        </Field>
                      </div>
                    </div>
                  </div> */}
                    {/* <div className="form-group row">
                    <label className="col-form-label col-lg-2">
                      Week Start Day:
                    </label>
                    <div className="col-lg-10">
                      <div className="input-group">
                        <Field
                          as="select"
                          className="form-control form-small select"
                          id="WeekStartDay"
                          name="WeekStartDay"
                          onChange={handleChange}
                        >
                          <option>Monday</option>
                          <option>Sunday</option>
                        </Field>
                      </div>
                    </div>
                  </div> */}
                    {/* <div className="form-group row">
                    <label className="col-form-label col-lg-2">
                      Store Opening Time:
                    </label>
                    <div className="col-lg-10">
                      <div className="input-group">
                        <span className="input-group-text" id="basic-addon1">
                          <img src={Time} alt="img" />
                        </span>
                        <TimePicker
                          value={time ? moment(time, "H:mm") : null}
                          onChange={(e) => {
                            onChange(e);
                            handleChange();
                          }}
                          showSecond={false}
                          style={{ width: "100%" }}
                          id="StoreOpeningTime"
                          name="StoreOpeningTime"
                        // onChange={handleChange}
                        />
                      </div>
                    </div>
                  </div> */}
                    {/* <div className="form-group row">
                    <label className="col-form-label col-lg-2">
                      Store Closing Time:
                    </label>
                    <div className="col-lg-10">
                      <div className="input-group">
                        <span className="input-group-text" id="basic-addon1">
                          <img src={Time} alt="img" />
                        </span>
                        <TimePicker
                          value={time ? moment(time, "H:mm") : null}
                          onChange={(e) => {
                            onChange(e);
                            handleChange();
                          }}
                          showSecond={false}
                          style={{ width: "100%" }}
                          id="StoreClosingTime"
                          name="StoreClosingTime"
                        />
                      </div>
                    </div>
                  </div> */}
                    {/* <div className="form-group row">
                    <label className="col-form-label col-lg-2 ">
                      PayVantage:
                    </label>
                    <div className="col-lg-10">
                      <div className="input-group">
                        <Field
                          className="form-check-input"
                          style={{ width: "1.5em", height: "1.5em" }}
                          type="checkbox"
                          id="PayVantage"
                          name="PayVantage"
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                  </div> */}
                    {/* <div className="form-group row">
                    <label className="col-form-label col-lg-2 ">
                      Enable Offline Mode:
                    </label>
                    <div className="col-lg-10">
                      <div className="input-group">
                        <Field
                          className="form-check-input"
                          style={{ width: "1.5em", height: "1.5em" }}
                          type="checkbox"
                          id="EnableOfflineMode"
                          name="EnableOfflineMode"
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                  </div> */}
                    {/* <div className="form-group row">
                    <label className="col-form-label col-lg-2 ">
                      Auto Sync Offline Sales When Back Online:
                    </label>
                    <div className="col-lg-10">
                      <div className="input-group">
                        <Field
                          className="form-check-input"
                          style={{ width: "1.5em", height: "1.5em" }}
                          type="checkbox"
                          id="AutoSyncOfflineSalesWhenBackOnline"
                          name="AutoSyncOfflineSalesWhenBackOnline"
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                  </div> */}
                    {/* <div className="form-group row">
                    <label className="col-form-label col-lg-2">
                      Offline Mode Sync Cycle Time (Hour):
                    </label>
                    <div className="col-lg-10">
                      <div className="input-group">
                        <Field
                          as="select"
                          className="form-control form-small select"
                          id="OfflineModeSyncCycleTime"
                          name="OfflineModeSyncCycleTime"
                          onChange={handleChange}
                        >
                          <option>1</option>
                          <option>2</option>
                          <option>3</option>
                          <option>4</option>
                          <option>5</option>
                          <option>6</option>
                          <option>7</option>
                          <option>8</option>
                          <option>9</option>
                          <option>10</option>
                          <option>11</option>
                          <option>12</option>
                          <option>13</option>
                          <option>14</option>
                          <option>15</option>
                          <option>16</option>
                          <option>17</option>
                          <option>18</option>
                          <option>19</option>
                          <option>20</option>
                          <option>21</option>
                          <option>22</option>
                          <option>23</option>
                          <option>24</option>
                          <option>25</option>
                          <option>26</option>
                          <option>27</option>
                          <option>28</option>
                          <option>29</option>
                          <option>30</option>
                          <option>31</option>
                          <option>32</option>
                          <option>33</option>
                          <option>34</option>
                          <option>35</option>
                          <option>36</option>
                          <option>37</option>
                          <option>38</option>
                          <option>39</option>
                          <option>40</option>
                          <option>41</option>
                          <option>42</option>
                          <option>43</option>
                          <option>44</option>
                          <option>45</option>
                          <option>46</option>
                          <option>47</option>
                          <option>48</option>
                        </Field>
                      </div>
                    </div>
                  </div> */}
                    {/* <div className="form-group row">
                                        <label className="col-form-label col-lg-2">
                                            Reset Offline Data:
                                        </label>
                                        <div className="col-lg-10">
                                            <div className="input-group">
                                                <button type="button" className="btn btn-primary me-1">
                                                    Reset Offline Data:
                                                </button>
                                            </div>
                                        </div>
                                    </div> */}
                    {/* <div className="form-group row">
                    <label className="col-form-label col-lg-2 ">
                      Dark Mode:
                    </label>
                    <div className="col-lg-10">
                      <div className="input-group">
                        <Field
                          className="form-check-input"
                          style={{ width: "1.5em", height: "1.5em" }}
                          type="checkbox"
                          id="DarkMode"
                          name="DarkMode"
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                  </div> */}
                    {/* <div className="form-group row">
                    <label className="col-form-label col-lg-2 ">
                      Only Allow Employees To Set Customers In Their Location:
                    </label>
                    <div className="col-lg-10">
                      <div className="input-group">
                        <Field
                          className="form-check-input"
                          style={{ width: "1.5em", height: "1.5em" }}
                          type="checkbox"
                          id="OnlyAllowEmployeesToSetCustomersInTheirLocation"
                          name="OnlyAllowEmployeesToSetCustomersInTheirLocation"
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                  </div> */}
                    {/* <div className="form-group row">
                    <label className="col-form-label col-lg-2 ">
                      Default New Customer To Current Location:
                    </label>
                    <div className="col-lg-10">
                      <div className="input-group">
                        <Field
                          className="form-check-input"
                          style={{ width: "1.5em", height: "1.5em" }}
                          type="checkbox"
                          id="DefaultNewCustomerToCurrentLocation"
                          name="DefaultNewCustomerToCurrentLocation"
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                  </div> */}
                    {/* <div className="form-group row">
                    <label className="col-form-label col-lg-2 ">
                      Only Allow Employees To See Employee With Location:
                    </label>
                    <div className="col-lg-10">
                      <div className="input-group">
                        <Field
                          className="form-check-input"
                          style={{ width: "1.5em", height: "1.5em" }}
                          type="checkbox"
                          id="OnlyAllowEmployeesToSeeEmployeeWithLocation"
                          name="OnlyAllowEmployeesToSeeEmployeeWithLocation"
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                  </div> */}
                    {/* <div className="form-group row">
                    <label className="col-form-label col-lg-2 ">
                      Require Https For Program:
                    </label>
                    <div className="col-lg-10">
                      <div className="input-group">
                        <Field
                          className="form-check-input"
                          style={{ width: "1.5em", height: "1.5em" }}
                          type="checkbox"
                          id="RequireHttpsForProgram"
                          name="RequireHttpsForProgram"
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                  </div> */}
                    {/* <div className="form-group row">
                    <label className="col-form-label col-lg-2 ">
                      Hide Expiring Items On Dashboard:
                    </label>
                    <div className="col-lg-10">
                      <div className="input-group">
                        <Field
                          className="form-check-input"
                          style={{ width: "1.5em", height: "1.5em" }}
                          type="checkbox"
                          id="HideExpiringItemsOnDashboard"
                          name="HideExpiringItemsOnDashboard"
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                  </div> */}
                    {/* <div className="form-group row">
                    <label className="col-form-label col-lg-2 ">
                      Do NOT Delete Saved Card After Failure:
                    </label>
                    <div className="col-lg-10">
                      <div className="input-group">
                        <Field
                          className="form-check-input"
                          style={{ width: "1.5em", height: "1.5em" }}
                          type="checkbox"
                          id="DoNOTDeleteSavedCardAfterFailure"
                          name="DoNOTDeleteSavedCardAfterFailure"
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                  </div> */}
                    {/* <div className="form-group row">
                    <label className="col-form-label col-lg-2 ">
                      Do Not Force HTTP When Needed For EMV Credit Card
                      Processing:
                    </label>
                    <div className="col-lg-10">
                      <div className="input-group">
                        <Field
                          className="form-check-input"
                          style={{ width: "1.5em", height: "1.5em" }}
                          type="checkbox"
                          id="DoNotForceHTTPWhenNeededForEMVCreditCardProcessing"
                          name="DoNotForceHTTPWhenNeededForEMVCreditCardProcessing"
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                  </div> */}
                    {/* <div className="form-group row">
                    <label className="col-form-label col-lg-2 ">
                      Disable Test Mode:
                    </label>
                    <div className="col-lg-10">
                      <div className="input-group">
                        <Field
                          className="form-check-input"
                          style={{ width: "1.5em", height: "1.5em" }}
                          type="checkbox"
                          id="DisableTestMode"
                          name="DisableTestMode"
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                  </div> */}
                    {/* <div className="form-group row">
                    <label className="col-form-label col-lg-2 ">
                      Hide Item Description In Reports:
                    </label>
                    <div className="col-lg-10">
                      <div className="input-group">
                        <Field
                          className="form-check-input"
                          style={{ width: "1.5em", height: "1.5em" }}
                          type="checkbox"
                          id="HideItemDescriptionInReports"
                          name="HideItemDescriptionInReports"
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                  </div> */}
                    {/* <div className="form-group row">
                    <label className="col-form-label col-lg-2 ">
                      Enable Sounds For Status Messages:
                    </label>
                    <div className="col-lg-10">
                      <div className="input-group">
                        <Field
                          className="form-check-input"
                          style={{ width: "1.5em", height: "1.5em" }}
                          type="checkbox"
                          id="EnableSoundsForStatusMessages"
                          name="EnableSoundsForStatusMessages"
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                  </div> */}
                    {/* <div className="form-group row">
                    <label className="col-form-label col-lg-2 ">
                      Show Language Switcher:
                    </label>
                    <div className="col-lg-10">
                      <div className="input-group">
                        <Field
                          className="form-check-input"
                          style={{ width: "1.5em", height: "1.5em" }}
                          type="checkbox"
                          id="ShowLanguageSwitcher"
                          name="ShowLanguageSwitcher"
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                  </div> */}
                    {/* <div className="form-group row">
                    <label className="col-form-label col-lg-2 ">
                      Show Clock In Header:
                    </label>
                    <div className="col-lg-10">
                      <div className="input-group">
                        <Field
                          className="form-check-input"
                          style={{ width: "1.5em", height: "1.5em" }}
                          type="checkbox"
                          id="ShowClockInHeader"
                          name="ShowClockInHeader"
                          onChange={handleChange}
                        />
                      </div>
                      This is visible only on wide screens
                    </div>
                  </div> */}
                    {/* <div className="form-group row">
                    <label className="col-form-label col-lg-2 ">
                      Legacy Detailed Report Excel Export:
                    </label>
                    <div className="col-lg-10">
                      <div className="input-group">
                        <Field
                          className="form-check-input"
                          style={{ width: "1.5em", height: "1.5em" }}
                          type="checkbox"
                          id="LegacyDetailedReportExcelExport"
                          name="LegacyDetailedReportExcelExport"
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                  </div> */}
                    {/* <div className="form-group row">
                    <label className="col-form-label col-lg-2 ">
                      Overwrite Existing Items On Excel Import:
                    </label>
                    <div className="col-lg-10">
                      <div className="input-group">
                        <Field
                          className="form-check-input"
                          style={{ width: "1.5em", height: "1.5em" }}
                          type="checkbox"
                          id="OverwriteExistingItemsOnExcelImport"
                          name="OverwriteExistingItemsOnExcelImport"
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                  </div> */}
                    {/* <div className="form-group row">
                    <label className="col-form-label col-lg-2">
                      Report Sort Order:
                    </label>
                    <div className="col-lg-10">
                      <div className="input-group">
                        <Field
                          as="select"
                          className="form-control form-small select"
                          id="ReportSortOrder"
                          name="ReportSortOrder"
                          onChange={handleChange}
                        >
                          <option>Oldest First</option>
                          <option>Newest First</option>
                        </Field>
                      </div>
                    </div>
                  </div> */}
                    {/* <div className="form-group row">
                    <label className="col-form-label col-lg-2 ">
                      Speed Up Search Queries? (Only Recommend If You Have More
                      Than 10,000 Items Or Customers):
                    </label>
                    <div className="col-lg-10">
                      <div className="input-group">
                        <Field
                          className="form-check-input"
                          style={{ width: "1.5em", height: "1.5em" }}
                          type="checkbox"
                          id="SpeedUpSearchQueries"
                          name="SpeedUpSearchQueries"
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                  </div> */}
                    {/* <div className="form-group row">
                    <label className="col-form-label col-lg-2 ">
                      Allow Partial Match For Customer Search:
                    </label>
                    <div className="col-lg-10">
                      <div className="input-group">
                        <Field
                          className="form-check-input"
                          style={{ width: "1.5em", height: "1.5em" }}
                          type="checkbox"
                          id="AllowPartialMatchForCustomerSearch"
                          name="AllowPartialMatchForCustomerSearch"
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                  </div> */}
                    {/* <div className="form-group row">
                    <label className="col-form-label col-lg-2 ">
                      Enable Quick Edit On Manage Pages:
                    </label>
                    <div className="col-lg-10">
                      <div className="input-group">
                        <Field
                          className="form-check-input"
                          style={{ width: "1.5em", height: "1.5em" }}
                          type="checkbox"
                          id="EnableQuickEditOnManagePages"
                          name="EnableQuickEditOnManagePages"
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                  </div> */}
                    {/* <div className="form-group row">
                    <label className="col-form-label col-lg-2 ">
                      Enable Quick Expense Add/Update:
                    </label>
                    <div className="col-lg-10">
                      <div className="input-group">
                        <Field
                          className="form-check-input"
                          style={{ width: "1.5em", height: "1.5em" }}
                          type="checkbox"
                          id="EnableQuickExpenseAddUpdate"
                          name="EnableQuickExpenseAddUpdate"
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                  </div> */}
                    {/* <div className="form-group row">
                    <label className="col-form-label col-lg-2 ">
                      Enhanced Search Method:
                    </label>
                    <div className="col-lg-10">
                      <div className="input-group">
                        <Field
                          className="form-check-input"
                          style={{ width: "1.5em", height: "1.5em" }}
                          type="checkbox"
                          id="EnhancedSearchMethod"
                          name="EnhancedSearchMethod"
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                  </div> */}
                    {/* <div className="form-group row">
                    <label className="col-form-label col-lg-2 ">
                      Include Child Categories When Searching Or Reporting:
                    </label>
                    <div className="col-lg-10">
                      <div className="input-group">
                        <Field
                          className="form-check-input"
                          style={{ width: "1.5em", height: "1.5em" }}
                          type="checkbox"
                          id="IncludeChildCategoriesWhenSearchingOrReporting"
                          name="IncludeChildCategoriesWhenSearchingOrReporting"
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                  </div> */}
                    {/* <div className="form-group row">
                    <label className="col-form-label col-lg-2 ">
                      Show Full Category Path When Searching:
                    </label>
                    <div className="col-lg-10">
                      <div className="input-group">
                        <Field
                          className="form-check-input"
                          style={{ width: "1.5em", height: "1.5em" }}
                          type="checkbox"
                          id="ShowFullCategoryPathWhenSearching"
                          name="ShowFullCategoryPathWhenSearching"
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                  </div> */}
                    {/* <div className="form-group row">
                    <label className="col-form-label col-lg-2">
                      Spreadsheet Format:
                    </label>
                    <div className="col-lg-10">
                      <div className="input-group">
                        <Field
                          as="select"
                          className="form-control form-small select"
                          id="SpreadsheetFormat"
                          name="SpreadsheetFormat"
                          onChange={handleChange}
                        >
                          <option>CSV</option>
                          <option>XLSX</option>
                        </Field>
                      </div>
                    </div>
                  </div> */}
                    {/* <div className="form-group row">
                    <label className="col-form-label col-lg-2">
                      Mailing Labels Format:
                    </label>
                    <div className="col-lg-10">
                      <div className="input-group">
                        <Field
                          as="select"
                          className="form-control form-small select"
                          id="MailingLabelsFormat"
                          name="MailingLabelsFormat"
                          onChange={handleChange}
                        >
                          <option>PDF</option>
                          <option>Excel</option>
                        </Field>
                      </div>
                    </div>
                  </div> */}
                    {/* <div className="form-group row">
                    <label className="col-form-label col-lg-2">
                      Session Expiration:
                    </label>
                    <div className="col-lg-10">
                      <div className="input-group">
                        <Field
                          as="select"
                          className="form-control form-small select"
                          id="SessionExpiration"
                          name="SessionExpiration"
                          onChange={handleChange}
                        >
                          <option value="0">On Browser Close</option>
                          <option value="600">10 Minutes</option>
                          <option value="900">15 Minutes</option>
                          <option value="1200">20 Minutes</option>
                          <option value="1500">25 Minutes</option>
                          <option value="1800">30 Minutes</option>
                          <option value="2100">35 Minutes</option>
                          <option value="2400">40 Minutes</option>
                          <option value="2700">45 Minutes</option>
                          <option value="3000">50 Minutes</option>
                          <option value="3300">55 Minutes</option>
                          <option value="3600">1 Hours</option>
                          <option value="7200">2 Hours</option>
                          <option value="10800">3 Hours</option>
                          <option value="14400">4 Hours</option>
                          <option value="18000">5 Hours</option>
                          <option value="21600">6 Hours</option>
                          <option value="25200">7 Hours</option>
                          <option value="28800">8 Hours</option>
                          <option value="32400">9 Hours</option>
                          <option value="36000">10 Hours</option>
                          <option value="39600">11 Hours</option>
                          <option value="43200">12 Hours</option>
                          <option value="46800">13 Hours</option>
                          <option value="50400">14 Hours</option>
                          <option value="54000">15 Hours</option>
                          <option value="57600">16 Hours</option>
                          <option value="61200">17 Hours</option>
                          <option value="64800">18 Hours</option>
                          <option value="68400">19 Hours</option>
                          <option value="72000">20 Hours</option>
                          <option value="75600">21 Hours</option>
                          <option value="79200">22 Hours</option>
                          <option value="82800">23 Hours</option>
                          <option value="86400">24 Hours</option>
                          <option value="90000">25 Hours</option>
                          <option value="93600">26 Hours</option>
                          <option value="97200">27 Hours</option>
                          <option value="100800">28 Hours</option>
                          <option value="104400">29 Hours</option>
                          <option value="108000">30 Hours</option>
                          <option value="111600">31 Hours</option>
                          <option value="115200">32 Hours</option>
                          <option value="118800">33 Hours</option>
                          <option value="122400">34 Hours</option>
                          <option value="126000">35 Hours</option>
                          <option value="129600">36 Hours</option>
                          <option value="133200">37 Hours</option>
                          <option value="136800">38 Hours</option>
                          <option value="140400">39 Hours</option>
                          <option value="144000">40 Hours</option>
                          <option value="147600">41 Hours</option>
                          <option value="151200">42 Hours</option>
                          <option value="154800">43 Hours</option>
                          <option value="158400">44 Hours</option>
                          <option value="162000">45 Hours</option>
                          <option value="165600">46 Hours</option>
                          <option value="169200">47 Hours</option>
                          <option value="172800">48 Hours</option>
                          <option value="176400">49 Hours</option>
                          <option value="180000">50 Hours</option>
                          <option value="183600">51 Hours</option>
                          <option value="187200">52 Hours</option>
                          <option value="190800">53 Hours</option>
                          <option value="194400">54 Hours</option>
                          <option value="198000">55 Hours</option>
                          <option value="201600">56 Hours</option>
                          <option value="205200">57 Hours</option>
                          <option value="208800">58 Hours</option>
                          <option value="212400">59 Hours</option>
                          <option value="216000">60 Hours</option>
                          <option value="219600">61 Hours</option>
                          <option value="223200">62 Hours</option>
                          <option value="226800">63 Hours</option>
                          <option value="230400">64 Hours</option>
                          <option value="234000">65 Hours</option>
                          <option value="237600">66 Hours</option>
                          <option value="241200">67 Hours</option>
                          <option value="244800">68 Hours</option>
                          <option value="248400">69 Hours</option>
                          <option value="252000">70 Hours</option>
                          <option value="255600">71 Hours</option>
                          <option value="259200">72 Hours</option>
                          <option value="262800">73 Hours</option>
                          <option value="266400">74 Hours</option>
                          <option value="270000">75 Hours</option>
                          <option value="273600">76 Hours</option>
                          <option value="277200">77 Hours</option>
                          <option value="280800">78 Hours</option>
                          <option value="284400">79 Hours</option>
                          <option value="288000">80 Hours</option>
                          <option value="291600">81 Hours</option>
                          <option value="295200">82 Hours</option>
                          <option value="298800">83 Hours</option>
                          <option value="302400">84 Hours</option>
                          <option value="306000">85 Hours</option>
                          <option value="309600">86 Hours</option>
                          <option value="313200">87 Hours</option>
                          <option value="316800">88 Hours</option>
                          <option value="320400">89 Hours</option>
                          <option value="324000">90 Hours</option>
                          <option value="327600">91 Hours</option>
                          <option value="331200">92 Hours</option>
                          <option value="334800">93 Hours</option>
                          <option value="338400">94 Hours</option>
                          <option value="342000">95 Hours</option>
                          <option value="345600">96 Hours</option>
                          <option value="349200">97 Hours</option>
                          <option value="352800">98 Hours</option>
                          <option value="356400">99 Hours</option>
                          <option value="360000">100 Hours</option>
                          <option value="363600">101 Hours</option>
                          <option value="367200">102 Hours</option>
                          <option value="370800">103 Hours</option>
                          <option value="374400">104 Hours</option>
                          <option value="378000">105 Hours</option>
                          <option value="381600">106 Hours</option>
                          <option value="385200">107 Hours</option>
                          <option value="388800">108 Hours</option>
                          <option value="392400">109 Hours</option>
                          <option value="396000">110 Hours</option>
                          <option value="399600">111 Hours</option>
                          <option value="403200">112 Hours</option>
                          <option value="406800">113 Hours</option>
                          <option value="410400">114 Hours</option>
                          <option value="414000">115 Hours</option>
                          <option value="417600">116 Hours</option>
                          <option value="421200">117 Hours</option>
                          <option value="424800">118 Hours</option>
                          <option value="428400">119 Hours</option>
                          <option value="432000">120 Hours</option>
                          <option value="435600">121 Hours</option>
                          <option value="439200">122 Hours</option>
                          <option value="442800">123 Hours</option>
                          <option value="446400">124 Hours</option>
                          <option value="450000">125 Hours</option>
                          <option value="453600">126 Hours</option>
                          <option value="457200">127 Hours</option>
                          <option value="460800">128 Hours</option>
                          <option value="464400">129 Hours</option>
                          <option value="468000">130 Hours</option>
                          <option value="471600">131 Hours</option>
                          <option value="475200">132 Hours</option>
                          <option value="478800">133 Hours</option>
                          <option value="482400">134 Hours</option>
                          <option value="486000">135 Hours</option>
                          <option value="489600">136 Hours</option>
                          <option value="493200">137 Hours</option>
                          <option value="496800">138 Hours</option>
                          <option value="500400">139 Hours</option>
                          <option value="504000">140 Hours</option>
                          <option value="507600">141 Hours</option>
                          <option value="511200">142 Hours</option>
                          <option value="514800">143 Hours</option>
                          <option value="518400">144 Hours</option>
                          <option value="522000">145 Hours</option>
                          <option value="525600">146 Hours</option>
                          <option value="529200">147 Hours</option>
                          <option value="532800">148 Hours</option>
                          <option value="536400">149 Hours</option>
                          <option value="540000">150 Hours</option>
                          <option value="543600">151 Hours</option>
                          <option value="547200">152 Hours</option>
                          <option value="550800">153 Hours</option>
                          <option value="554400">154 Hours</option>
                          <option value="558000">155 Hours</option>
                          <option value="561600">156 Hours</option>
                          <option value="565200">157 Hours</option>
                          <option value="568800">158 Hours</option>
                          <option value="572400">159 Hours</option>
                          <option value="576000">160 Hours</option>
                          <option value="579600">161 Hours</option>
                          <option value="583200">162 Hours</option>
                          <option value="586800">163 Hours</option>
                          <option value="590400">164 Hours</option>
                          <option value="594000">165 Hours</option>
                          <option value="597600">166 Hours</option>
                          <option value="601200">167 Hours</option>
                          <option value="604800">168 Hours</option>
                        </Field>
                      </div>
                    </div>
                  </div> */}
                    {/* <div className="form-group row">
                    <label className="col-form-label col-lg-2 ">
                      Always Minimize Left Side Bar Menu:
                    </label>
                    <div className="col-lg-10">
                      <div className="input-group">
                        <Field
                          className="form-check-input"
                          style={{ width: "1.5em", height: "1.5em" }}
                          type="checkbox"
                          id="AlwaysMinimizeLeftSideBarMenu"
                          name="AlwaysMinimizeLeftSideBarMenu"
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                  </div> */}
                    {/* <div className="form-group row">
                    <label className="col-form-label col-lg-2 ">
                      Allow Scan Of Customer Into Item Field:
                    </label>
                    <div className="col-lg-10">
                      <div className="input-group">
                        <Field
                          className="form-check-input"
                          style={{ width: "1.5em", height: "1.5em" }}
                          type="checkbox"
                          id="AllowScanOfCustomerIntoItemField"
                          name="AllowScanOfCustomerIntoItemField"
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                  </div> */}
                    {/* <div className="form-group row">
                    <label className="col-form-label col-lg-2 ">
                      Send SMS Via Whatsapp:
                    </label>
                    <div className="col-lg-10">
                      <div className="input-group">
                        <Field
                          className="form-check-input"
                          style={{ width: "1.5em", height: "1.5em" }}
                          type="checkbox"
                          id="SendSMSViaWhatsapp"
                          name="SendSMSViaWhatsapp"
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                  </div> */}
                    {/* <div className="form-group row">
                    <label className="col-form-label col-lg-2 ">
                      Enable Quick Customer Add/Update:
                    </label>
                    <div className="col-lg-10">
                      <div className="input-group">
                        <Field
                          className="form-check-input"
                          style={{ width: "1.5em", height: "1.5em" }}
                          type="checkbox"
                          id="EnableQuickCustomerAddUpdate"
                          name="EnableQuickCustomerAddUpdate"
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                  </div> */}
                    {/* <div className="form-group row">
                    <label className="col-form-label col-lg-2 ">
                      Enable Quick Supplier Add/Update:
                    </label>
                    <div className="col-lg-10">
                      <div className="input-group">
                        <Field
                          className="form-check-input"
                          style={{ width: "1.5em", height: "1.5em" }}
                          type="checkbox"
                          id="EnableQuickSupplierAddUpdate"
                          name="EnableQuickSupplierAddUpdate"
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                  </div> */}
                    {/* <div className="form-group row">
                    <label className="col-form-label col-lg-2 ">
                      Enable Quick Item Add/Update:
                    </label>
                    <div className="col-lg-10">
                      <div className="input-group">
                        <Field
                          className="form-check-input"
                          style={{ width: "1.5em", height: "1.5em" }}
                          type="checkbox"
                          id="EnableQuickItemAddUpdate"
                          name="EnableQuickItemAddUpdate"
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                  </div> */}
                    {/* <div className="form-group row">
                    <label className="col-form-label col-lg-2">
                      Additional Appointment Note **Bold**, ~~Italic~~,
                      ||Underline|| Here, You Can Use Some Keywords.
                    </label>
                    <div className="col-lg-10">
                      <div className="input-group">
                        <Field
                          as="textarea"
                          className="form-control"
                          rows={3}
                          id="AdditionalAppointmentNoteBoldItalicUnderlineHereYouCanUseSomeKeywords"
                          name="AdditionalAppointmentNoteBoldItalicUnderlineHereYouCanUseSomeKeywords"
                          onChange={handleChange}
                        ></Field>
                      </div>
                    </div>
                  </div> */}
                    {/* <div className="form-group row">
                    <label className="col-form-label col-lg-2 ">
                      Do NOT Delete Serial Number When Selling:
                    </label>
                    <div className="col-lg-10">
                      <div className="input-group">
                        <Field
                          className="form-check-input"
                          style={{ width: "1.5em", height: "1.5em" }}
                          type="checkbox"
                          id="DoNOTDeleteSerialNumberWhenSelling"
                          name="DoNOTDeleteSerialNumberWhenSelling"
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                  </div> */}
                    <button
                      type="submit"
                      className="btn btn-primary pull-right mb-3"
                    >
                      Save
                    </button>
                  </Form>
                )}
              </Formik>
            </div>
          </CCollapse>
        </div>
      ) : (
        matchesSearchQuery.length !== 0 && (
          <div className="card">
            <div className="card-header">
              <h5 className="card-title">
                <CLink
                  onClick={() => {
                    setVisibleApplicationSettings(!visibleApplicationSettings);
                    setcomingApplicationSettings(!!comingApplicationSettings);
                  }}
                >
                  Application Settings
                </CLink>
              </h5>
            </div>
            <CCollapse
              visible={
                visibleApplicationSettings ||
                props.visibleApplicationSettingsChange
              }
            >
              <div className="card-body">
                <span className="text-danger">
                  Language cannot be saved at application level. However the
                  default admin employee can change the language using the
                  selector in the header of the program
                </span>
                <br />
                <br />
                <Formik
                  {...props}
                  initialValues={formValues}
                  onSubmit={handleSubmit}
                  enableReinitialize
                >
                  {({ handleChange }) => (
                    <Form>
                      <div
                        style={{
                          display: "flex",
                          width: "60%",
                          flexDirection: "column",
                          alignItems: "flex-start",
                        }}
                      >
                        {matchesSearchQuery &&
                          matchesSearchQuery?.map((el) => (
                            <div
                              style={{
                                width: "100%",
                                display: "flex",
                                justifyContent: "space-between",
                                marginTop: "10px",
                              }}
                            >
                              <label
                                className="col-form-label"
                                style={{ fontSize: "15px" }}
                              >
                                {el.name}
                              </label>
                              <div style={{ width: "53%" }}>{el.input}</div>
                            </div>
                          ))}
                      </div>
                      {/* <div className="form-group row">
                    <label className="col-form-label col-lg-2">Language:</label>
                    <div className="col-lg-10">
                      <div className="input-group">
                        <Field
                          as="select"
                          className="form-control form-small select"
                          id="Language"
                          name="Language"
                          onChange={handleChange}
                        >
                          <option>English</option>
                          <option>Indonesia</option>
                          <option>Española</option>
                          <option>Fançais</option>
                          <option>Italiano</option>
                          <option>Deutsch</option>
                          <option>Nederlands</option>
                          <option>Portugues</option>
                          <option>العَرَبِيةُ‎‎</option>
                          <option>Khmer</option>
                          <option>Vietnamese</option>
                          <option>中文</option>
                          <option>繁體中文</option>
                          <option>Tamil</option>
                        </Field>
                      </div>
                    </div>
                  </div> */}
                      {/* <div className="form-group row">
                    <label className="col-form-label col-lg-2">
                      Date Format:
                    </label>
                    <div className="col-lg-10">
                      <div className="input-group">
                        <Field
                          as="select"
                          className="form-control form-small select"
                          id="DateFormat"
                          name="DateFormat"
                          onChange={handleChange}
                        >
                          <option>12/30/2000</option>
                          <option>30-12-2000</option>
                          <option>2000-12-30</option>
                        </Field>
                      </div>
                    </div>
                  </div> */}
                      {/* <div className="form-group row">
                    <label className="col-form-label col-lg-2">
                      Time Format:
                    </label>
                    <div className="col-lg-10">
                      <div className="input-group">
                        <Field
                          as="select"
                          className="form-control form-small select"
                          id="TimeFormat"
                          name="TimeFormat"
                          onChange={handleChange}
                        >
                          <option>1:00 PM</option>
                          <option>13:00</option>
                        </Field>
                      </div>
                    </div>
                  </div> */}
                      {/* <div className="form-group row">
                    <label className="col-form-label col-lg-2">
                      Week Start Day:
                    </label>
                    <div className="col-lg-10">
                      <div className="input-group">
                        <Field
                          as="select"
                          className="form-control form-small select"
                          id="WeekStartDay"
                          name="WeekStartDay"
                          onChange={handleChange}
                        >
                          <option>Monday</option>
                          <option>Sunday</option>
                        </Field>
                      </div>
                    </div>
                  </div> */}
                      {/* <div className="form-group row">
                    <label className="col-form-label col-lg-2">
                      Store Opening Time:
                    </label>
                    <div className="col-lg-10">
                      <div className="input-group">
                        <span className="input-group-text" id="basic-addon1">
                          <img src={Time} alt="img" />
                        </span>
                        <TimePicker
                          value={time ? moment(time, "H:mm") : null}
                          onChange={(e) => {
                            onChange(e);
                            handleChange();
                          }}
                          showSecond={false}
                          style={{ width: "100%" }}
                          id="StoreOpeningTime"
                          name="StoreOpeningTime"
                        // onChange={handleChange}
                        />
                      </div>
                    </div>
                  </div> */}
                      {/* <div className="form-group row">
                    <label className="col-form-label col-lg-2">
                      Store Closing Time:
                    </label>
                    <div className="col-lg-10">
                      <div className="input-group">
                        <span className="input-group-text" id="basic-addon1">
                          <img src={Time} alt="img" />
                        </span>
                        <TimePicker
                          value={time ? moment(time, "H:mm") : null}
                          onChange={(e) => {
                            onChange(e);
                            handleChange();
                          }}
                          showSecond={false}
                          style={{ width: "100%" }}
                          id="StoreClosingTime"
                          name="StoreClosingTime"
                        />
                      </div>
                    </div>
                  </div> */}
                      {/* <div className="form-group row">
                    <label className="col-form-label col-lg-2 ">
                      PayVantage:
                    </label>
                    <div className="col-lg-10">
                      <div className="input-group">
                        <Field
                          className="form-check-input"
                          style={{ width: "1.5em", height: "1.5em" }}
                          type="checkbox"
                          id="PayVantage"
                          name="PayVantage"
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                  </div> */}
                      {/* <div className="form-group row">
                    <label className="col-form-label col-lg-2 ">
                      Enable Offline Mode:
                    </label>
                    <div className="col-lg-10">
                      <div className="input-group">
                        <Field
                          className="form-check-input"
                          style={{ width: "1.5em", height: "1.5em" }}
                          type="checkbox"
                          id="EnableOfflineMode"
                          name="EnableOfflineMode"
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                  </div> */}
                      {/* <div className="form-group row">
                    <label className="col-form-label col-lg-2 ">
                      Auto Sync Offline Sales When Back Online:
                    </label>
                    <div className="col-lg-10">
                      <div className="input-group">
                        <Field
                          className="form-check-input"
                          style={{ width: "1.5em", height: "1.5em" }}
                          type="checkbox"
                          id="AutoSyncOfflineSalesWhenBackOnline"
                          name="AutoSyncOfflineSalesWhenBackOnline"
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                  </div> */}
                      {/* <div className="form-group row">
                    <label className="col-form-label col-lg-2">
                      Offline Mode Sync Cycle Time (Hour):
                    </label>
                    <div className="col-lg-10">
                      <div className="input-group">
                        <Field
                          as="select"
                          className="form-control form-small select"
                          id="OfflineModeSyncCycleTime"
                          name="OfflineModeSyncCycleTime"
                          onChange={handleChange}
                        >
                          <option>1</option>
                          <option>2</option>
                          <option>3</option>
                          <option>4</option>
                          <option>5</option>
                          <option>6</option>
                          <option>7</option>
                          <option>8</option>
                          <option>9</option>
                          <option>10</option>
                          <option>11</option>
                          <option>12</option>
                          <option>13</option>
                          <option>14</option>
                          <option>15</option>
                          <option>16</option>
                          <option>17</option>
                          <option>18</option>
                          <option>19</option>
                          <option>20</option>
                          <option>21</option>
                          <option>22</option>
                          <option>23</option>
                          <option>24</option>
                          <option>25</option>
                          <option>26</option>
                          <option>27</option>
                          <option>28</option>
                          <option>29</option>
                          <option>30</option>
                          <option>31</option>
                          <option>32</option>
                          <option>33</option>
                          <option>34</option>
                          <option>35</option>
                          <option>36</option>
                          <option>37</option>
                          <option>38</option>
                          <option>39</option>
                          <option>40</option>
                          <option>41</option>
                          <option>42</option>
                          <option>43</option>
                          <option>44</option>
                          <option>45</option>
                          <option>46</option>
                          <option>47</option>
                          <option>48</option>
                        </Field>
                      </div>
                    </div>
                  </div> */}
                      {/* <div className="form-group row">
                                        <label className="col-form-label col-lg-2">
                                            Reset Offline Data:
                                        </label>
                                        <div className="col-lg-10">
                                            <div className="input-group">
                                                <button type="button" className="btn btn-primary me-1">
                                                    Reset Offline Data:
                                                </button>
                                            </div>
                                        </div>
                                    </div> */}
                      {/* <div className="form-group row">
                    <label className="col-form-label col-lg-2 ">
                      Dark Mode:
                    </label>
                    <div className="col-lg-10">
                      <div className="input-group">
                        <Field
                          className="form-check-input"
                          style={{ width: "1.5em", height: "1.5em" }}
                          type="checkbox"
                          id="DarkMode"
                          name="DarkMode"
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                  </div> */}
                      {/* <div className="form-group row">
                    <label className="col-form-label col-lg-2 ">
                      Only Allow Employees To Set Customers In Their Location:
                    </label>
                    <div className="col-lg-10">
                      <div className="input-group">
                        <Field
                          className="form-check-input"
                          style={{ width: "1.5em", height: "1.5em" }}
                          type="checkbox"
                          id="OnlyAllowEmployeesToSetCustomersInTheirLocation"
                          name="OnlyAllowEmployeesToSetCustomersInTheirLocation"
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                  </div> */}
                      {/* <div className="form-group row">
                    <label className="col-form-label col-lg-2 ">
                      Default New Customer To Current Location:
                    </label>
                    <div className="col-lg-10">
                      <div className="input-group">
                        <Field
                          className="form-check-input"
                          style={{ width: "1.5em", height: "1.5em" }}
                          type="checkbox"
                          id="DefaultNewCustomerToCurrentLocation"
                          name="DefaultNewCustomerToCurrentLocation"
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                  </div> */}
                      {/* <div className="form-group row">
                    <label className="col-form-label col-lg-2 ">
                      Only Allow Employees To See Employee With Location:
                    </label>
                    <div className="col-lg-10">
                      <div className="input-group">
                        <Field
                          className="form-check-input"
                          style={{ width: "1.5em", height: "1.5em" }}
                          type="checkbox"
                          id="OnlyAllowEmployeesToSeeEmployeeWithLocation"
                          name="OnlyAllowEmployeesToSeeEmployeeWithLocation"
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                  </div> */}
                      {/* <div className="form-group row">
                    <label className="col-form-label col-lg-2 ">
                      Require Https For Program:
                    </label>
                    <div className="col-lg-10">
                      <div className="input-group">
                        <Field
                          className="form-check-input"
                          style={{ width: "1.5em", height: "1.5em" }}
                          type="checkbox"
                          id="RequireHttpsForProgram"
                          name="RequireHttpsForProgram"
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                  </div> */}
                      {/* <div className="form-group row">
                    <label className="col-form-label col-lg-2 ">
                      Hide Expiring Items On Dashboard:
                    </label>
                    <div className="col-lg-10">
                      <div className="input-group">
                        <Field
                          className="form-check-input"
                          style={{ width: "1.5em", height: "1.5em" }}
                          type="checkbox"
                          id="HideExpiringItemsOnDashboard"
                          name="HideExpiringItemsOnDashboard"
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                  </div> */}
                      {/* <div className="form-group row">
                    <label className="col-form-label col-lg-2 ">
                      Do NOT Delete Saved Card After Failure:
                    </label>
                    <div className="col-lg-10">
                      <div className="input-group">
                        <Field
                          className="form-check-input"
                          style={{ width: "1.5em", height: "1.5em" }}
                          type="checkbox"
                          id="DoNOTDeleteSavedCardAfterFailure"
                          name="DoNOTDeleteSavedCardAfterFailure"
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                  </div> */}
                      {/* <div className="form-group row">
                    <label className="col-form-label col-lg-2 ">
                      Do Not Force HTTP When Needed For EMV Credit Card
                      Processing:
                    </label>
                    <div className="col-lg-10">
                      <div className="input-group">
                        <Field
                          className="form-check-input"
                          style={{ width: "1.5em", height: "1.5em" }}
                          type="checkbox"
                          id="DoNotForceHTTPWhenNeededForEMVCreditCardProcessing"
                          name="DoNotForceHTTPWhenNeededForEMVCreditCardProcessing"
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                  </div> */}
                      {/* <div className="form-group row">
                    <label className="col-form-label col-lg-2 ">
                      Disable Test Mode:
                    </label>
                    <div className="col-lg-10">
                      <div className="input-group">
                        <Field
                          className="form-check-input"
                          style={{ width: "1.5em", height: "1.5em" }}
                          type="checkbox"
                          id="DisableTestMode"
                          name="DisableTestMode"
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                  </div> */}
                      {/* <div className="form-group row">
                    <label className="col-form-label col-lg-2 ">
                      Hide Item Description In Reports:
                    </label>
                    <div className="col-lg-10">
                      <div className="input-group">
                        <Field
                          className="form-check-input"
                          style={{ width: "1.5em", height: "1.5em" }}
                          type="checkbox"
                          id="HideItemDescriptionInReports"
                          name="HideItemDescriptionInReports"
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                  </div> */}
                      {/* <div className="form-group row">
                    <label className="col-form-label col-lg-2 ">
                      Enable Sounds For Status Messages:
                    </label>
                    <div className="col-lg-10">
                      <div className="input-group">
                        <Field
                          className="form-check-input"
                          style={{ width: "1.5em", height: "1.5em" }}
                          type="checkbox"
                          id="EnableSoundsForStatusMessages"
                          name="EnableSoundsForStatusMessages"
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                  </div> */}
                      {/* <div className="form-group row">
                    <label className="col-form-label col-lg-2 ">
                      Show Language Switcher:
                    </label>
                    <div className="col-lg-10">
                      <div className="input-group">
                        <Field
                          className="form-check-input"
                          style={{ width: "1.5em", height: "1.5em" }}
                          type="checkbox"
                          id="ShowLanguageSwitcher"
                          name="ShowLanguageSwitcher"
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                  </div> */}
                      {/* <div className="form-group row">
                    <label className="col-form-label col-lg-2 ">
                      Show Clock In Header:
                    </label>
                    <div className="col-lg-10">
                      <div className="input-group">
                        <Field
                          className="form-check-input"
                          style={{ width: "1.5em", height: "1.5em" }}
                          type="checkbox"
                          id="ShowClockInHeader"
                          name="ShowClockInHeader"
                          onChange={handleChange}
                        />
                      </div>
                      This is visible only on wide screens
                    </div>
                  </div> */}
                      {/* <div className="form-group row">
                    <label className="col-form-label col-lg-2 ">
                      Legacy Detailed Report Excel Export:
                    </label>
                    <div className="col-lg-10">
                      <div className="input-group">
                        <Field
                          className="form-check-input"
                          style={{ width: "1.5em", height: "1.5em" }}
                          type="checkbox"
                          id="LegacyDetailedReportExcelExport"
                          name="LegacyDetailedReportExcelExport"
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                  </div> */}
                      {/* <div className="form-group row">
                    <label className="col-form-label col-lg-2 ">
                      Overwrite Existing Items On Excel Import:
                    </label>
                    <div className="col-lg-10">
                      <div className="input-group">
                        <Field
                          className="form-check-input"
                          style={{ width: "1.5em", height: "1.5em" }}
                          type="checkbox"
                          id="OverwriteExistingItemsOnExcelImport"
                          name="OverwriteExistingItemsOnExcelImport"
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                  </div> */}
                      {/* <div className="form-group row">
                    <label className="col-form-label col-lg-2">
                      Report Sort Order:
                    </label>
                    <div className="col-lg-10">
                      <div className="input-group">
                        <Field
                          as="select"
                          className="form-control form-small select"
                          id="ReportSortOrder"
                          name="ReportSortOrder"
                          onChange={handleChange}
                        >
                          <option>Oldest First</option>
                          <option>Newest First</option>
                        </Field>
                      </div>
                    </div>
                  </div> */}
                      {/* <div className="form-group row">
                    <label className="col-form-label col-lg-2 ">
                      Speed Up Search Queries? (Only Recommend If You Have More
                      Than 10,000 Items Or Customers):
                    </label>
                    <div className="col-lg-10">
                      <div className="input-group">
                        <Field
                          className="form-check-input"
                          style={{ width: "1.5em", height: "1.5em" }}
                          type="checkbox"
                          id="SpeedUpSearchQueries"
                          name="SpeedUpSearchQueries"
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                  </div> */}
                      {/* <div className="form-group row">
                    <label className="col-form-label col-lg-2 ">
                      Allow Partial Match For Customer Search:
                    </label>
                    <div className="col-lg-10">
                      <div className="input-group">
                        <Field
                          className="form-check-input"
                          style={{ width: "1.5em", height: "1.5em" }}
                          type="checkbox"
                          id="AllowPartialMatchForCustomerSearch"
                          name="AllowPartialMatchForCustomerSearch"
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                  </div> */}
                      {/* <div className="form-group row">
                    <label className="col-form-label col-lg-2 ">
                      Enable Quick Edit On Manage Pages:
                    </label>
                    <div className="col-lg-10">
                      <div className="input-group">
                        <Field
                          className="form-check-input"
                          style={{ width: "1.5em", height: "1.5em" }}
                          type="checkbox"
                          id="EnableQuickEditOnManagePages"
                          name="EnableQuickEditOnManagePages"
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                  </div> */}
                      {/* <div className="form-group row">
                    <label className="col-form-label col-lg-2 ">
                      Enable Quick Expense Add/Update:
                    </label>
                    <div className="col-lg-10">
                      <div className="input-group">
                        <Field
                          className="form-check-input"
                          style={{ width: "1.5em", height: "1.5em" }}
                          type="checkbox"
                          id="EnableQuickExpenseAddUpdate"
                          name="EnableQuickExpenseAddUpdate"
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                  </div> */}
                      {/* <div className="form-group row">
                    <label className="col-form-label col-lg-2 ">
                      Enhanced Search Method:
                    </label>
                    <div className="col-lg-10">
                      <div className="input-group">
                        <Field
                          className="form-check-input"
                          style={{ width: "1.5em", height: "1.5em" }}
                          type="checkbox"
                          id="EnhancedSearchMethod"
                          name="EnhancedSearchMethod"
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                  </div> */}
                      {/* <div className="form-group row">
                    <label className="col-form-label col-lg-2 ">
                      Include Child Categories When Searching Or Reporting:
                    </label>
                    <div className="col-lg-10">
                      <div className="input-group">
                        <Field
                          className="form-check-input"
                          style={{ width: "1.5em", height: "1.5em" }}
                          type="checkbox"
                          id="IncludeChildCategoriesWhenSearchingOrReporting"
                          name="IncludeChildCategoriesWhenSearchingOrReporting"
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                  </div> */}
                      {/* <div className="form-group row">
                    <label className="col-form-label col-lg-2 ">
                      Show Full Category Path When Searching:
                    </label>
                    <div className="col-lg-10">
                      <div className="input-group">
                        <Field
                          className="form-check-input"
                          style={{ width: "1.5em", height: "1.5em" }}
                          type="checkbox"
                          id="ShowFullCategoryPathWhenSearching"
                          name="ShowFullCategoryPathWhenSearching"
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                  </div> */}
                      {/* <div className="form-group row">
                    <label className="col-form-label col-lg-2">
                      Spreadsheet Format:
                    </label>
                    <div className="col-lg-10">
                      <div className="input-group">
                        <Field
                          as="select"
                          className="form-control form-small select"
                          id="SpreadsheetFormat"
                          name="SpreadsheetFormat"
                          onChange={handleChange}
                        >
                          <option>CSV</option>
                          <option>XLSX</option>
                        </Field>
                      </div>
                    </div>
                  </div> */}
                      {/* <div className="form-group row">
                    <label className="col-form-label col-lg-2">
                      Mailing Labels Format:
                    </label>
                    <div className="col-lg-10">
                      <div className="input-group">
                        <Field
                          as="select"
                          className="form-control form-small select"
                          id="MailingLabelsFormat"
                          name="MailingLabelsFormat"
                          onChange={handleChange}
                        >
                          <option>PDF</option>
                          <option>Excel</option>
                        </Field>
                      </div>
                    </div>
                  </div> */}
                      {/* <div className="form-group row">
                    <label className="col-form-label col-lg-2">
                      Session Expiration:
                    </label>
                    <div className="col-lg-10">
                      <div className="input-group">
                        <Field
                          as="select"
                          className="form-control form-small select"
                          id="SessionExpiration"
                          name="SessionExpiration"
                          onChange={handleChange}
                        >
                          <option value="0">On Browser Close</option>
                          <option value="600">10 Minutes</option>
                          <option value="900">15 Minutes</option>
                          <option value="1200">20 Minutes</option>
                          <option value="1500">25 Minutes</option>
                          <option value="1800">30 Minutes</option>
                          <option value="2100">35 Minutes</option>
                          <option value="2400">40 Minutes</option>
                          <option value="2700">45 Minutes</option>
                          <option value="3000">50 Minutes</option>
                          <option value="3300">55 Minutes</option>
                          <option value="3600">1 Hours</option>
                          <option value="7200">2 Hours</option>
                          <option value="10800">3 Hours</option>
                          <option value="14400">4 Hours</option>
                          <option value="18000">5 Hours</option>
                          <option value="21600">6 Hours</option>
                          <option value="25200">7 Hours</option>
                          <option value="28800">8 Hours</option>
                          <option value="32400">9 Hours</option>
                          <option value="36000">10 Hours</option>
                          <option value="39600">11 Hours</option>
                          <option value="43200">12 Hours</option>
                          <option value="46800">13 Hours</option>
                          <option value="50400">14 Hours</option>
                          <option value="54000">15 Hours</option>
                          <option value="57600">16 Hours</option>
                          <option value="61200">17 Hours</option>
                          <option value="64800">18 Hours</option>
                          <option value="68400">19 Hours</option>
                          <option value="72000">20 Hours</option>
                          <option value="75600">21 Hours</option>
                          <option value="79200">22 Hours</option>
                          <option value="82800">23 Hours</option>
                          <option value="86400">24 Hours</option>
                          <option value="90000">25 Hours</option>
                          <option value="93600">26 Hours</option>
                          <option value="97200">27 Hours</option>
                          <option value="100800">28 Hours</option>
                          <option value="104400">29 Hours</option>
                          <option value="108000">30 Hours</option>
                          <option value="111600">31 Hours</option>
                          <option value="115200">32 Hours</option>
                          <option value="118800">33 Hours</option>
                          <option value="122400">34 Hours</option>
                          <option value="126000">35 Hours</option>
                          <option value="129600">36 Hours</option>
                          <option value="133200">37 Hours</option>
                          <option value="136800">38 Hours</option>
                          <option value="140400">39 Hours</option>
                          <option value="144000">40 Hours</option>
                          <option value="147600">41 Hours</option>
                          <option value="151200">42 Hours</option>
                          <option value="154800">43 Hours</option>
                          <option value="158400">44 Hours</option>
                          <option value="162000">45 Hours</option>
                          <option value="165600">46 Hours</option>
                          <option value="169200">47 Hours</option>
                          <option value="172800">48 Hours</option>
                          <option value="176400">49 Hours</option>
                          <option value="180000">50 Hours</option>
                          <option value="183600">51 Hours</option>
                          <option value="187200">52 Hours</option>
                          <option value="190800">53 Hours</option>
                          <option value="194400">54 Hours</option>
                          <option value="198000">55 Hours</option>
                          <option value="201600">56 Hours</option>
                          <option value="205200">57 Hours</option>
                          <option value="208800">58 Hours</option>
                          <option value="212400">59 Hours</option>
                          <option value="216000">60 Hours</option>
                          <option value="219600">61 Hours</option>
                          <option value="223200">62 Hours</option>
                          <option value="226800">63 Hours</option>
                          <option value="230400">64 Hours</option>
                          <option value="234000">65 Hours</option>
                          <option value="237600">66 Hours</option>
                          <option value="241200">67 Hours</option>
                          <option value="244800">68 Hours</option>
                          <option value="248400">69 Hours</option>
                          <option value="252000">70 Hours</option>
                          <option value="255600">71 Hours</option>
                          <option value="259200">72 Hours</option>
                          <option value="262800">73 Hours</option>
                          <option value="266400">74 Hours</option>
                          <option value="270000">75 Hours</option>
                          <option value="273600">76 Hours</option>
                          <option value="277200">77 Hours</option>
                          <option value="280800">78 Hours</option>
                          <option value="284400">79 Hours</option>
                          <option value="288000">80 Hours</option>
                          <option value="291600">81 Hours</option>
                          <option value="295200">82 Hours</option>
                          <option value="298800">83 Hours</option>
                          <option value="302400">84 Hours</option>
                          <option value="306000">85 Hours</option>
                          <option value="309600">86 Hours</option>
                          <option value="313200">87 Hours</option>
                          <option value="316800">88 Hours</option>
                          <option value="320400">89 Hours</option>
                          <option value="324000">90 Hours</option>
                          <option value="327600">91 Hours</option>
                          <option value="331200">92 Hours</option>
                          <option value="334800">93 Hours</option>
                          <option value="338400">94 Hours</option>
                          <option value="342000">95 Hours</option>
                          <option value="345600">96 Hours</option>
                          <option value="349200">97 Hours</option>
                          <option value="352800">98 Hours</option>
                          <option value="356400">99 Hours</option>
                          <option value="360000">100 Hours</option>
                          <option value="363600">101 Hours</option>
                          <option value="367200">102 Hours</option>
                          <option value="370800">103 Hours</option>
                          <option value="374400">104 Hours</option>
                          <option value="378000">105 Hours</option>
                          <option value="381600">106 Hours</option>
                          <option value="385200">107 Hours</option>
                          <option value="388800">108 Hours</option>
                          <option value="392400">109 Hours</option>
                          <option value="396000">110 Hours</option>
                          <option value="399600">111 Hours</option>
                          <option value="403200">112 Hours</option>
                          <option value="406800">113 Hours</option>
                          <option value="410400">114 Hours</option>
                          <option value="414000">115 Hours</option>
                          <option value="417600">116 Hours</option>
                          <option value="421200">117 Hours</option>
                          <option value="424800">118 Hours</option>
                          <option value="428400">119 Hours</option>
                          <option value="432000">120 Hours</option>
                          <option value="435600">121 Hours</option>
                          <option value="439200">122 Hours</option>
                          <option value="442800">123 Hours</option>
                          <option value="446400">124 Hours</option>
                          <option value="450000">125 Hours</option>
                          <option value="453600">126 Hours</option>
                          <option value="457200">127 Hours</option>
                          <option value="460800">128 Hours</option>
                          <option value="464400">129 Hours</option>
                          <option value="468000">130 Hours</option>
                          <option value="471600">131 Hours</option>
                          <option value="475200">132 Hours</option>
                          <option value="478800">133 Hours</option>
                          <option value="482400">134 Hours</option>
                          <option value="486000">135 Hours</option>
                          <option value="489600">136 Hours</option>
                          <option value="493200">137 Hours</option>
                          <option value="496800">138 Hours</option>
                          <option value="500400">139 Hours</option>
                          <option value="504000">140 Hours</option>
                          <option value="507600">141 Hours</option>
                          <option value="511200">142 Hours</option>
                          <option value="514800">143 Hours</option>
                          <option value="518400">144 Hours</option>
                          <option value="522000">145 Hours</option>
                          <option value="525600">146 Hours</option>
                          <option value="529200">147 Hours</option>
                          <option value="532800">148 Hours</option>
                          <option value="536400">149 Hours</option>
                          <option value="540000">150 Hours</option>
                          <option value="543600">151 Hours</option>
                          <option value="547200">152 Hours</option>
                          <option value="550800">153 Hours</option>
                          <option value="554400">154 Hours</option>
                          <option value="558000">155 Hours</option>
                          <option value="561600">156 Hours</option>
                          <option value="565200">157 Hours</option>
                          <option value="568800">158 Hours</option>
                          <option value="572400">159 Hours</option>
                          <option value="576000">160 Hours</option>
                          <option value="579600">161 Hours</option>
                          <option value="583200">162 Hours</option>
                          <option value="586800">163 Hours</option>
                          <option value="590400">164 Hours</option>
                          <option value="594000">165 Hours</option>
                          <option value="597600">166 Hours</option>
                          <option value="601200">167 Hours</option>
                          <option value="604800">168 Hours</option>
                        </Field>
                      </div>
                    </div>
                  </div> */}
                      {/* <div className="form-group row">
                    <label className="col-form-label col-lg-2 ">
                      Always Minimize Left Side Bar Menu:
                    </label>
                    <div className="col-lg-10">
                      <div className="input-group">
                        <Field
                          className="form-check-input"
                          style={{ width: "1.5em", height: "1.5em" }}
                          type="checkbox"
                          id="AlwaysMinimizeLeftSideBarMenu"
                          name="AlwaysMinimizeLeftSideBarMenu"
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                  </div> */}
                      {/* <div className="form-group row">
                    <label className="col-form-label col-lg-2 ">
                      Allow Scan Of Customer Into Item Field:
                    </label>
                    <div className="col-lg-10">
                      <div className="input-group">
                        <Field
                          className="form-check-input"
                          style={{ width: "1.5em", height: "1.5em" }}
                          type="checkbox"
                          id="AllowScanOfCustomerIntoItemField"
                          name="AllowScanOfCustomerIntoItemField"
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                  </div> */}
                      {/* <div className="form-group row">
                    <label className="col-form-label col-lg-2 ">
                      Send SMS Via Whatsapp:
                    </label>
                    <div className="col-lg-10">
                      <div className="input-group">
                        <Field
                          className="form-check-input"
                          style={{ width: "1.5em", height: "1.5em" }}
                          type="checkbox"
                          id="SendSMSViaWhatsapp"
                          name="SendSMSViaWhatsapp"
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                  </div> */}
                      {/* <div className="form-group row">
                    <label className="col-form-label col-lg-2 ">
                      Enable Quick Customer Add/Update:
                    </label>
                    <div className="col-lg-10">
                      <div className="input-group">
                        <Field
                          className="form-check-input"
                          style={{ width: "1.5em", height: "1.5em" }}
                          type="checkbox"
                          id="EnableQuickCustomerAddUpdate"
                          name="EnableQuickCustomerAddUpdate"
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                  </div> */}
                      {/* <div className="form-group row">
                    <label className="col-form-label col-lg-2 ">
                      Enable Quick Supplier Add/Update:
                    </label>
                    <div className="col-lg-10">
                      <div className="input-group">
                        <Field
                          className="form-check-input"
                          style={{ width: "1.5em", height: "1.5em" }}
                          type="checkbox"
                          id="EnableQuickSupplierAddUpdate"
                          name="EnableQuickSupplierAddUpdate"
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                  </div> */}
                      {/* <div className="form-group row">
                    <label className="col-form-label col-lg-2 ">
                      Enable Quick Item Add/Update:
                    </label>
                    <div className="col-lg-10">
                      <div className="input-group">
                        <Field
                          className="form-check-input"
                          style={{ width: "1.5em", height: "1.5em" }}
                          type="checkbox"
                          id="EnableQuickItemAddUpdate"
                          name="EnableQuickItemAddUpdate"
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                  </div> */}
                      {/* <div className="form-group row">
                    <label className="col-form-label col-lg-2">
                      Additional Appointment Note **Bold**, ~~Italic~~,
                      ||Underline|| Here, You Can Use Some Keywords.
                    </label>
                    <div className="col-lg-10">
                      <div className="input-group">
                        <Field
                          as="textarea"
                          className="form-control"
                          rows={3}
                          id="AdditionalAppointmentNoteBoldItalicUnderlineHereYouCanUseSomeKeywords"
                          name="AdditionalAppointmentNoteBoldItalicUnderlineHereYouCanUseSomeKeywords"
                          onChange={handleChange}
                        ></Field>
                      </div>
                    </div>
                  </div> */}
                      {/* <div className="form-group row">
                    <label className="col-form-label col-lg-2 ">
                      Do NOT Delete Serial Number When Selling:
                    </label>
                    <div className="col-lg-10">
                      <div className="input-group">
                        <Field
                          className="form-check-input"
                          style={{ width: "1.5em", height: "1.5em" }}
                          type="checkbox"
                          id="DoNOTDeleteSerialNumberWhenSelling"
                          name="DoNOTDeleteSerialNumberWhenSelling"
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                  </div> */}
                      <button
                        type="submit"
                        className="btn btn-primary pull-right mb-3"
                      >
                        Save
                      </button>
                    </Form>
                  )}
                </Formik>
              </div>
            </CCollapse>
          </div>
        )
      )}
    </>
  );
};

export default ApplicationSettings;
